var _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPDesigning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-15"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-15",
    cx: 250,
    cy: 349.67,
    rx: 243.71,
    ry: 136.02,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-15",
    d: "M221.89,434l39.16-22.6c1.45-.84,1.45-2.2,0-3l-9.55-5.51a5.8,5.8,0,0,0-5.26,0l-39.16,22.6c-1.45.84-1.45,2.2,0,3l3.06,1.77-41.79,24.12c-1.45.84-1.84,2-.86,2.54s2.94.34,4.39-.5l41.79-24.12,3,1.7A5.8,5.8,0,0,0,221.89,434Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-15",
    d: "M228.93,466.68a19.81,19.81,0,0,1-9.85-2.41l-.46-.28a2,2,0,0,1-.88-2.05,2.11,2.11,0,0,1,1.93-1.6l10-1.46.53-1.11-2.39-1.4L218,457.8l-.34,0a2.38,2.38,0,0,1-2-3.66,9.9,9.9,0,0,1,3.6-3.26,20,20,0,0,1,9.68-2.32,23,23,0,0,1,4,.35l41.6-24a6.11,6.11,0,0,1-.07-3.23,8.6,8.6,0,0,1,4.46-5.23,21.36,21.36,0,0,1,19.54.09l.46.28a1.93,1.93,0,0,1,.87,2,2.1,2.1,0,0,1-1.9,1.6l-10,1.46-.53,1.11,2.39,1.4,9.8-1.43.34,0a2.36,2.36,0,0,1,2.08,1.23,2.4,2.4,0,0,1-.07,2.43,10.29,10.29,0,0,1-3.61,3.26,19.93,19.93,0,0,1-9.68,2.31,24.11,24.11,0,0,1-4-.34l-41.6,24a6,6,0,0,1,.08,3.23,8.71,8.71,0,0,1-4.46,5.24A20,20,0,0,1,228.93,466.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-15",
    d: "M16.75,374.61,69.29,405a4.79,4.79,0,0,0,4.33,0L308.2,269.73a1.33,1.33,0,0,0,0-2.51l-52.31-30.45a4.76,4.76,0,0,0-4.33,0L16.75,372.11A1.32,1.32,0,0,0,16.75,374.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-15",
    d: "M130.8,441.67a15.87,15.87,0,0,1-4.29-.61c-4.21-1.19-5.51-3.38-5.87-5-.57-2.66,1-5.4,2.85-6.94.65-.56,1.41-1.14,2.19-1.74,2-1.56,4.56-3.5,5.14-5l2.86-7.32-2.16-1.24.47-1.08-2.24.48-1-1.35c-2.24,1.08-7.72,3.73-15.07,7.41-1.7.85-3.12,1.58-4.37,2.22-4.13,2.13-6.41,3.31-9.85,4.14a17.12,17.12,0,0,1-3.9.48c-2.7,0-4.82-.77-6.12-2.22a6.13,6.13,0,0,1-1.36-5c.77-6.9,14.22-12.92,21.22-13.55,2.29-.21,4.45-.3,6.8-.3,1.14,0,2.15,0,3.07,0l2,0c.62,0,1.18,0,1.69-.06,2.65-.25,10.88-1.77,11-1.78l.9-.17.55.73,2-.39c2.72-1.93,23.51-16.66,28.42-20,3.06-2.1,8.55-5.43,10.21-5.43h.89l.56.83.42.79-.56.93a41.09,41.09,0,0,1-7.85,9c-1.76,1.38-6.81,5.68-11.83,10l38-7.37L193.89,395c-.47.79-2.93,3.05-15.75,6.84-7.71,2.27-21.8,5.54-32.4,7.9l-1.73,1.5c-.12,1.89-.5,7.64-.76,10.66a11.63,11.63,0,0,0,.55,3.59c.65,2.54,1.45,5.7-.64,8.93C141.41,437.1,137.46,441.67,130.8,441.67Zm2.68-10.94a6.93,6.93,0,0,0-5,1.95,1.73,1.73,0,0,0-.51,1.46,2.29,2.29,0,0,0,1.67,1.24,5.92,5.92,0,0,0,1.67.22,6.91,6.91,0,0,0,5-2,1.71,1.71,0,0,0,.51-1.46,2.27,2.27,0,0,0-1.66-1.24A6,6,0,0,0,133.48,430.73ZM114,410.54a26.79,26.79,0,0,0-8.19,1.42c-7.3,2.4-9.59,5.38-10.31,7-.09.2-.29.69-.12.95a1.48,1.48,0,0,0,1.22.43,3,3,0,0,0,.72-.09,11.5,11.5,0,0,0,3.78-1.82,46.17,46.17,0,0,1,4.59-2.6A87.48,87.48,0,0,1,117.48,411l.12,0A13.13,13.13,0,0,0,114,410.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-15",
    d: "M441,356.52c-8.21,4.63-8.3,12.27-.19,17.07s21.35,5,29.57.32,8.3-12.27.18-17.07S449.17,351.9,441,356.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-15",
    d: "M280.81,347c-22,12.41-22.26,32.92-.49,45.8s57.28,13.27,79.32.86,22.27-32.92.5-45.81S302.85,334.55,280.81,347Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-15",
    d: "M381,275.45c-19.61,11-19.81,29.28-.44,40.75s50.95,11.8,70.57.76,19.81-29.29.44-40.75S400.59,264.4,381,275.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-15",
    d: "M191.47,361.3c-3.39,1.73,5.74,8.37,10,6.05l72.9-42.78,8.36-10a.59.59,0,0,0-.6-1l-17.22,5.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-15",
    d: "M364.87,408.53l10.45-6.06a12.57,12.57,0,0,1,11.41,0l3.64,2.1,13.6-7.85a4.91,4.91,0,0,1,4.45,0l.09.05a1.36,1.36,0,0,1,0,2.57l-13.6,7.85.76.44c3.15,1.82,3.15,4.78,0,6.6l-10.46,6.06L370,429.1,349.6,417.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-15",
    d: "M449.87,408.8a4,4,0,0,0-.21-.35l-.14-.21-.16-.23c-.12-.16-.26-.33-.41-.51a5.37,5.37,0,0,0-.52-.57,10.56,10.56,0,0,0-1.38-1.18l-.25-.17-.06,0-.23-.13a9.34,9.34,0,0,0-3.43-1.19l-.59-.06h-.61c-.2,0-.4,0-.61.05l-.27,0-.22,0-.13,0-.15,0a3.11,3.11,0,0,0-.41.11h0l-.53.2h0a6.16,6.16,0,0,0-1,.53,9.94,9.94,0,0,0-1.74,1.46,9.19,9.19,0,0,0-.66.76,11.22,11.22,0,0,0-.78,1.16c-.15.25-.29.5-.41.75l-.19.37c-.23.49-.43,1-.63,1.39-.83.39-34.7,19.84-42.12,24.4l-.06,0-.95.59c-9.73,6.07-20.9,16.43-20.9,16.43h0a.93.93,0,0,0-.13.15.87.87,0,0,0,.2,1.21.85.85,0,0,0,.77.12H371a158.26,158.26,0,0,0,23.74-11.74c7.84-4.9,40.33-26.53,41.63-27.58a9.29,9.29,0,0,0,5.25-.28A9.16,9.16,0,0,0,446,411h0a7.2,7.2,0,0,1,.95-1,3.72,3.72,0,0,1,3.07-.92A3,3,0,0,0,449.87,408.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-15",
    d: "M388,425.8c-8.81,7.34-18.62,19-18.62,19h0a.91.91,0,0,0-.11.16.87.87,0,0,0,1.13,1.2h.05a156.77,156.77,0,0,0,22-14.7c5.3-4.35,10.3-9.09,13.56-12.3h0c1.39-1.3,2.67-2.58,3.79-3.82h0a9.46,9.46,0,0,0,5.18-1,9.17,9.17,0,0,0,3.93-4h0a7.65,7.65,0,0,1,.82-1.08,3.72,3.72,0,0,1,2.92-1.3,3.06,3.06,0,0,0-.19-.29l-.25-.31-.17-.19-.19-.21h0c-.14-.15-.3-.3-.47-.46s-.37-.33-.59-.5a10.83,10.83,0,0,0-1.52-1l-.27-.13-.07,0-.24-.11a9.34,9.34,0,0,0-3.55-.73,4,4,0,0,0-.6,0l-.6.06-.6.12-.26.08-.22.06-.12,0-.15.06-.39.16,0,0-.49.26h0a6.49,6.49,0,0,0-.89.65,11.19,11.19,0,0,0-1.54,1.67c-.2.28-.39.56-.55.84a11.26,11.26,0,0,0-.63,1.25c-.12.27-.22.54-.31.8l-.14.39c-.17.52-.31,1-.45,1.46C405.94,412.92,395.43,419.63,388,425.8Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Prototyping--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plan--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.42,261.36v3.26L71,400.31l-1.41-.81a56.49,56.49,0,0,1-28.15-48.77V167.62L276.84,31.93l2.83,1.63V215A53.49,53.49,0,0,0,306.42,261.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.42,261.36,71,397.05a53.51,53.51,0,0,1-26.74-46.32V169.25L279.67,33.56V215A53.49,53.49,0,0,0,306.42,261.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.27,350.73V169.25l-2.82-1.63V350.73A56.49,56.49,0,0,0,69.6,399.5l1.41.81v-3.26A53.51,53.51,0,0,1,44.27,350.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.01 397.05 71.01 400.31 306.42 264.62 306.42 261.36 71.01 397.05",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tape--inject-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "276.6 62.09 273.84 63.43 273.71 59.69 270.96 61.03 270.82 57.29 268.07 58.63 267.94 54.89 265.18 56.24 265.05 52.49 262.3 53.84 262.17 50.09 278.73 17.96 281.49 16.61 281.62 20.36 284.38 19.01 284.51 22.75 287.26 21.41 287.39 25.15 290.15 23.81 290.28 27.55 293.04 26.21 293.17 29.95 276.6 62.09",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.6 62.09 273.84 63.43 273.71 59.69 270.96 61.03 270.82 57.29 268.07 58.63 267.94 54.89 265.18 56.24 265.05 52.49 262.3 53.84 262.17 50.09 278.73 17.96 281.49 16.61 281.62 20.36 284.38 19.01 284.51 22.75 287.26 21.41 287.39 25.15 290.15 23.81 290.28 27.55 293.04 26.21 293.17 29.95 276.6 62.09",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--tape--inject-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "21.35 162.17 20.61 158.72 23.22 158.27 22.48 154.82 25.08 154.37 24.34 150.92 26.95 150.47 26.21 147.02 28.81 146.57 28.07 143.12 30.68 142.67 61.37 170.13 62.11 173.57 59.5 174.02 60.24 177.47 57.64 177.92 58.38 181.37 55.77 181.82 56.51 185.27 53.91 185.72 54.65 189.17 52.04 189.62 21.35 162.17",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.35 162.17 20.61 158.72 23.22 158.27 22.48 154.82 25.08 154.37 24.34 150.92 26.95 150.47 26.21 147.02 28.81 146.57 28.07 143.12 30.68 142.67 61.37 170.13 62.11 173.57 59.5 174.02 60.24 177.47 57.64 177.92 58.38 181.37 55.77 181.82 56.51 185.27 53.91 185.72 54.65 189.17 52.04 189.62 21.35 162.17",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Drawings--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.21,349.08A6.75,6.75,0,0,1,79,349c-2.58-.5-3.88-2.57-3.47-5.56l0-.23,2.24-12a.51.51,0,0,1,.59-.4.5.5,0,0,1,.4.58l-2.3,12.23c-.18,1.38-.1,3.86,2.68,4.4,4,.77,10.6-3.08,14.68-8.57,2.24-3,3.32-6,3-8.17v-.05l-2.28-9.47a.49.49,0,0,1,.37-.6.51.51,0,0,1,.6.37l2.3,9.55a.57.57,0,0,1,0,.13c.35,2.43-.8,5.64-3.17,8.83C90.75,345.28,84.57,349.08,80.21,349.08Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.91,341.48a5.45,5.45,0,0,1-1.09-.1,3.78,3.78,0,0,1-3.2-3.81.5.5,0,0,1,.48-.52.48.48,0,0,1,.52.48A2.79,2.79,0,0,0,80,340.4c3.54.68,9.39-2.73,13-7.61a12.3,12.3,0,0,0,2.69-6.29.5.5,0,0,1,.52-.48.52.52,0,0,1,.48.53,13.24,13.24,0,0,1-2.89,6.83C90.34,338.08,84.81,341.48,80.91,341.48Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.91,336.55a5.45,5.45,0,0,1-1.09-.1,3.75,3.75,0,0,1-2.55-1.62.5.5,0,0,1,.14-.69.49.49,0,0,1,.69.15,2.79,2.79,0,0,0,1.9,1.18c3.56.68,9.4-2.73,13-7.61A15.59,15.59,0,0,0,95.18,324a.5.5,0,0,1,.65-.29.49.49,0,0,1,.29.64,16.73,16.73,0,0,1-2.29,4.09C90.34,333.15,84.81,336.55,80.91,336.55Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.29,346.22a6.61,6.61,0,0,1-1.2-.11,3.9,3.9,0,0,1-3.28-4.27.51.51,0,0,1,.51-.49.49.49,0,0,1,.49.51,2.93,2.93,0,0,0,2.47,3.26c4,.77,10.45-3,14.47-8.44,1.81-2.43,2.82-4.9,2.78-6.78a.5.5,0,0,1,.49-.51h0a.51.51,0,0,1,.5.49c0,2.13-1,4.75-3,7.39C90.7,342.46,84.6,346.22,80.29,346.22Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.41,331.86a6.61,6.61,0,0,1-1.36-.13,4.47,4.47,0,0,1-3.68-3.16l-.05-.17a216.26,216.26,0,0,1-6.87-54.72c0-31.85,10.15-63.94,17.17-74l.2-.29,0-.05h0a5.32,5.32,0,0,1,1.56-1.46,2.61,2.61,0,0,1,1.71-.37h.05l.31.09c7.08,1.92,17.39,22.42,17.39,54.41,0,29.67-6.15,59.32-6.86,62.6a18.51,18.51,0,0,1-3.42,7C91.22,327.59,84.29,331.86,79.41,331.86ZM85.65,200c-.09.12-.15.21-.2.29-7,9.92-17,41.75-17,73.39a215.55,215.55,0,0,0,6.83,54.45l0,.15a3.46,3.46,0,0,0,2.9,2.47c4.55.88,12-3.46,16.57-9.65a17.76,17.76,0,0,0,3.25-6.64c.7-3.27,6.83-32.82,6.83-62.39,0-31.5-9.87-51.6-16.7-53.46l-.17-.05h0a1.52,1.52,0,0,0-1.06.25A4.45,4.45,0,0,0,85.66,200Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.52,222.56a6.26,6.26,0,0,1-1.16-.1,3.9,3.9,0,0,1-3.27-3.08.5.5,0,0,1,0-.27c1-3.16,2.07-6.11,3.13-8.76a55.75,55.75,0,0,1,5.39-10.62l.19-.28a.47.47,0,0,1,.09-.12,5.34,5.34,0,0,1,1.52-1.4,2.59,2.59,0,0,1,1.71-.37h.09l0,0,.22.06c1.76.47,3.69,2,5.56,4.53a34.46,34.46,0,0,1,3.17,5.21.47.47,0,0,1,0,.31,15.29,15.29,0,0,1-3,6.23C90.57,218.94,84.68,222.56,80.52,222.56Zm-3.42-3.28a2.84,2.84,0,0,0,2.44,2.19c3.8.74,10.07-2.91,13.95-8.14a14.85,14.85,0,0,0,2.75-5.64,33.32,33.32,0,0,0-3-4.91h0c-1.73-2.31-3.48-3.75-5.06-4.18l-.12,0H88a1.55,1.55,0,0,0-1,.25A4.58,4.58,0,0,0,85.66,200l0,0a.22.22,0,0,1-.06.07l-.14.22a54.57,54.57,0,0,0-5.28,10.42C79.12,213.31,78.09,216.19,77.1,219.28Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.41,258.81a4.63,4.63,0,0,1-2.35-.61c-2-1.14-3.09-3.71-3.09-7.07,0-6.18,3.79-13.4,8.45-16.09,2.13-1.23,4.21-1.39,5.86-.44,2,1.14,3.09,3.71,3.09,7.07,0,6.18-3.79,13.4-8.45,16.09A7.06,7.06,0,0,1,83.41,258.81ZM89.93,235a6.15,6.15,0,0,0-3,.91c-4.38,2.53-8,9.36-8,15.23,0,3,.94,5.25,2.59,6.2,1.32.76,3,.61,4.86-.43,4.38-2.53,8-9.37,8-15.23,0-3-.94-5.25-2.59-6.2A3.65,3.65,0,0,0,89.93,235Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.33,255.44a3.52,3.52,0,0,1-1.75-.46c-1.45-.84-2.29-2.73-2.29-5.19,0-4.48,2.75-9.71,6.13-11.66a4.27,4.27,0,0,1,4.34-.31c1.45.84,2.28,2.73,2.28,5.19,0,4.48-2.74,9.71-6.12,11.66A5.26,5.26,0,0,1,84.33,255.44ZM89,238.36a4.26,4.26,0,0,0-2.08.64c-3.1,1.79-5.63,6.63-5.63,10.79,0,2.09.65,3.67,1.79,4.32a3.32,3.32,0,0,0,3.34-.31C89.52,252,92,247.17,92,243c0-2.09-.64-3.67-1.78-4.32A2.44,2.44,0,0,0,89,238.36Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.91,317.43h-.08l-17.24-3a.49.49,0,0,1-.33-.21.48.48,0,0,1-.07-.39c2.06-9.41,3.72-22,5.07-33.14a.55.55,0,0,1,.51-.44.5.5,0,0,1,.49.46c0,.57.08,1.29.12,2.1.15,3.34.39,8.38,2,11.45,1.49,2.77,3.9,5.4,6.69,8.44.77.84,1.58,1.72,2.41,2.64,2.88,3.23,2,8,.87,11.77A.5.5,0,0,1,115.91,317.43ZM99.27,313.5l16.29,2.86c1.4-5,1.15-8.22-.79-10.39-.82-.92-1.62-1.79-2.39-2.63-2.84-3.09-5.29-5.76-6.84-8.65-1.24-2.3-1.73-5.54-2-8.46C102.38,295.68,101,305.64,99.27,313.5Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.5,314.89h0l-17.28-3.35a.25.25,0,0,1-.16-.11.23.23,0,0,1,0-.18c.18-.9.36-1.81.53-2.75a.29.29,0,0,1,.11-.16.25.25,0,0,1,.19,0L117,311.63a.23.23,0,0,1,.2.26,18.13,18.13,0,0,1-.42,2.8A.24.24,0,0,1,116.5,314.89Zm-17-3.79,16.8,3.25a21,21,0,0,0,.34-2.28L100,308.84C99.81,309.61,99.66,310.36,99.51,311.1Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.43,351.2h-.06a.49.49,0,0,1-.4-.29c-1.66-3.74-1.42-7.62.77-12.59q1.23-2.81,2.39-5.38c2.81-6.32,5.24-11.77,6.76-16.33a51.36,51.36,0,0,0,2.07-14c0-.85.08-1.61.12-2.24a.51.51,0,0,1,.48-.46.5.5,0,0,1,.52.43c1.35,9.55,3,20.25,5.06,27.25a.46.46,0,0,1-.08.44L57.82,351A.5.5,0,0,1,57.43,351.2Zm12.38-45.65a45.6,45.6,0,0,1-2,11.36c-1.53,4.61-4,10.09-6.8,16.43-.77,1.71-1.56,3.51-2.39,5.38-2.35,5.35-1.94,8.66-1.09,11l16.55-22A187,187,0,0,1,69.81,305.55Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.84,349.34h0a.24.24,0,0,1-.2-.17,11.7,11.7,0,0,1-.42-2.35.18.18,0,0,1,0-.16L73.39,323.5a.24.24,0,0,1,.25-.09.25.25,0,0,1,.19.18c.18.74.35,1.45.53,2.13a.22.22,0,0,1,0,.21L57,349.23A.24.24,0,0,1,56.84,349.34Zm-.16-2.47a11.35,11.35,0,0,0,.27,1.65l16.9-22.79c-.13-.49-.25-1-.38-1.5Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.67,198.86a.5.5,0,0,1-.5-.5V187.11a.5.5,0,0,1,1,0v11.25A.5.5,0,0,1,86.67,198.86Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.05,187.8a1.24,1.24,0,0,1-.65-.17,1.87,1.87,0,0,1-.79-1.69,4.24,4.24,0,0,1,1.81-3.41,1.52,1.52,0,0,1,1.52-.08,1.87,1.87,0,0,1,.79,1.69,4.24,4.24,0,0,1-1.81,3.41A1.73,1.73,0,0,1,86.05,187.8Zm1.24-4.52a.81.81,0,0,0-.37.12,3.23,3.23,0,0,0-1.31,2.54c0,.48.15.74.29.82s.39,0,.52-.08a3.23,3.23,0,0,0,1.31-2.54c0-.48-.15-.74-.29-.82A.28.28,0,0,0,87.29,183.28Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.93,234.19a.47.47,0,0,1-.25-.07.49.49,0,0,1-.18-.68l8-13.82a.52.52,0,0,1,.18-.18l34.58-20a.51.51,0,0,1,.69.18.52.52,0,0,1-.19.69l-34.46,19.89-7.91,13.71A.51.51,0,0,1,120.93,234.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.63,211.52a3,3,0,0,1,1.42-2.36L156.15,197c.78-.45,1.42-.13,1.42.72a3,3,0,0,1-1.42,2.35l-21.1,12.19C134.26,212.69,133.63,212.37,133.63,211.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.38,229.45l9.44-5.45c.44-.26.8-.08.8.4a1.71,1.71,0,0,1-.8,1.33l-9.44,5.46c-.45.25-.81.07-.81-.41A1.7,1.7,0,0,1,132.38,229.45Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.18,222.63l8.73-5c.44-.25.8-.07.8.41a1.71,1.71,0,0,1-.8,1.33l-8.73,5c-.45.26-.81.08-.8-.4A1.72,1.72,0,0,1,144.18,222.63Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.32,216.2l6.23-3.6c.44-.26.8-.08.8.4a1.75,1.75,0,0,1-.8,1.34l-6.23,3.59c-.44.26-.8.08-.8-.4A1.71,1.71,0,0,1,155.32,216.2Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.38,223.27,150.18,213c.45-.26.81-.08.81.4a1.73,1.73,0,0,1-.81,1.34L132.38,225c-.45.26-.81.08-.81-.4A1.7,1.7,0,0,1,132.38,223.27Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.76,211.49l8.53-4.91c.44-.26.8-.08.8.4a1.75,1.75,0,0,1-.8,1.34l-8.53,4.91c-.44.26-.8.07-.8-.41A1.73,1.73,0,0,1,152.76,211.49Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.93,271.1a.57.57,0,0,1-.25-.06.51.51,0,0,1-.18-.69l8-13.82a.62.62,0,0,1,.18-.18l34.58-20a.5.5,0,1,1,.5.86l-34.46,19.9-7.91,13.7A.51.51,0,0,1,120.93,271.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.63,248.43a3,3,0,0,1,1.42-2.35l21.1-12.19c.78-.45,1.42-.13,1.42.72a3.07,3.07,0,0,1-1.42,2.36l-21.1,12.18C134.26,249.6,133.63,249.28,133.63,248.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.38,266.36l9.44-5.45c.44-.26.8-.07.8.41a1.73,1.73,0,0,1-.8,1.33l-9.44,5.45c-.45.26-.81.07-.81-.41A1.71,1.71,0,0,1,132.38,266.36Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.18,259.55l8.73-5c.44-.26.8-.08.8.4a1.75,1.75,0,0,1-.8,1.34l-8.73,5c-.45.25-.81.07-.8-.41A1.69,1.69,0,0,1,144.18,259.55Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.32,253.11l6.23-3.6c.44-.25.8-.07.8.41a1.73,1.73,0,0,1-.8,1.33l-6.23,3.6c-.44.25-.8.07-.8-.41A1.73,1.73,0,0,1,155.32,253.11Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.38,260.18l17.8-10.28c.45-.25.81-.07.81.41a1.71,1.71,0,0,1-.81,1.33l-17.8,10.28c-.45.25-.81.07-.81-.41A1.71,1.71,0,0,1,132.38,260.18Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.76,248.41l8.53-4.92c.44-.25.8-.07.8.41a1.73,1.73,0,0,1-.8,1.33l-8.53,4.91c-.44.26-.8.08-.8-.4A1.71,1.71,0,0,1,152.76,248.41Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.36,213a.52.52,0,0,1-.25-.07.5.5,0,0,1-.25-.43v-55.4a.51.51,0,0,1,.43-.5.51.51,0,0,1,.55.35c.22.72.45,1.63.72,2.66,1.08,4.24,2.72,10.65,6.1,13.52,3.07,2.61,7.57,4.4,12.78,6.48q2.16.85,4.48,1.81c5.42,2.26,5.17,9.06,4.36,14.73a.47.47,0,0,1-.25.36L185.61,212.9A.59.59,0,0,1,185.36,213Zm.51-52.07v50.7l27.47-15.86c1.08-7.74-.09-11.89-3.78-13.43-1.54-.64-3-1.23-4.47-1.8-5.29-2.11-9.86-3.93-13.05-6.64C188.68,171,187,165.21,185.87,160.9Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.36,209.8a.52.52,0,0,1-.25-.07.5.5,0,0,1-.25-.43v-3.91a.5.5,0,0,1,.25-.44l28.76-16.6a.48.48,0,0,1,.48,0,.46.46,0,0,1,.26.39,22.51,22.51,0,0,1,0,4,.48.48,0,0,1-.25.4l-28.79,16.63A.59.59,0,0,1,185.36,209.8Zm.5-4.13v2.76l27.81-16.06a23.18,23.18,0,0,0,0-2.76Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.46,161.76a.59.59,0,0,1-.25-.07A.49.49,0,0,1,222,161l8-13.83a.62.62,0,0,1,.18-.18l34.58-20a.5.5,0,0,1,.5.86l-34.46,19.9-7.91,13.71A.51.51,0,0,1,222.46,161.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.16,139.09a3,3,0,0,1,1.42-2.36l21.1-12.18c.78-.46,1.42-.13,1.42.71a3.05,3.05,0,0,1-1.42,2.36l-21.1,12.18C235.79,140.25,235.16,139.93,235.16,139.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.91,157l9.44-5.45c.44-.25.8-.07.8.41a1.73,1.73,0,0,1-.8,1.33l-9.45,5.45c-.44.26-.8.08-.8-.4A1.73,1.73,0,0,1,233.91,157Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.71,150.2l8.73-5c.44-.26.8-.08.8.4a1.75,1.75,0,0,1-.8,1.34l-8.73,5c-.45.26-.81.07-.81-.41A1.71,1.71,0,0,1,245.71,150.2Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.85,143.76l6.23-3.6c.44-.25.8-.07.8.41a1.71,1.71,0,0,1-.8,1.33l-6.23,3.6c-.45.26-.8.07-.8-.41A1.7,1.7,0,0,1,256.85,143.76Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.91,150.83l17.8-10.28c.45-.25.8-.07.8.41a1.69,1.69,0,0,1-.8,1.33L233.9,152.57c-.44.26-.8.07-.8-.41A1.71,1.71,0,0,1,233.91,150.83Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.29,139.06l8.52-4.92c.45-.25.81-.07.81.41a1.7,1.7,0,0,1-.81,1.33l-8.52,4.92c-.44.25-.8.07-.8-.41A1.71,1.71,0,0,1,254.29,139.06Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fin--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.46,249.55a.47.47,0,0,1-.25-.07.49.49,0,0,1-.18-.68L230,235a.55.55,0,0,1,.18-.19l34.58-20a.5.5,0,0,1,.5.86l-34.46,19.9L222.9,249.3A.51.51,0,0,1,222.46,249.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.16,226.88a3,3,0,0,1,1.42-2.36l21.1-12.18c.78-.45,1.42-.13,1.42.71a3.05,3.05,0,0,1-1.42,2.36l-21.1,12.18C235.79,228.05,235.16,227.72,235.16,226.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.91,244.8l9.44-5.45c.44-.25.8-.07.8.41a1.71,1.71,0,0,1-.8,1.33l-9.45,5.45c-.44.26-.8.08-.8-.4A1.73,1.73,0,0,1,233.91,244.8Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.71,238l8.73-5c.44-.26.8-.07.8.41a1.73,1.73,0,0,1-.8,1.33l-8.73,5c-.45.26-.81.07-.81-.41A1.71,1.71,0,0,1,245.71,238Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.85,231.55l6.23-3.6c.44-.25.8-.07.8.41a1.71,1.71,0,0,1-.8,1.33l-6.23,3.6c-.45.26-.8.07-.8-.41A1.7,1.7,0,0,1,256.85,231.55Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.91,238.62l17.8-10.28c.45-.25.8-.07.8.41a1.69,1.69,0,0,1-.8,1.33L233.9,240.36c-.44.26-.8.08-.8-.41A1.71,1.71,0,0,1,233.91,238.62Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.29,226.85l8.52-4.92c.45-.25.81-.07.81.41a1.7,1.7,0,0,1-.81,1.33l-8.52,4.92c-.44.25-.8.07-.8-.41A1.71,1.71,0,0,1,254.29,226.85Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.35,273.64a6.79,6.79,0,0,1-3.43-.9c-2.89-1.67-4.54-5.49-4.54-10.48,0-9.28,5.68-20.12,12.66-24.15,3.15-1.82,6.21-2.05,8.62-.66,2.89,1.67,4.55,5.49,4.55,10.48,0,9.28-5.69,20.12-12.67,24.15A10.52,10.52,0,0,1,198.35,273.64Zm9.88-36.08a9.51,9.51,0,0,0-4.69,1.41c-6.71,3.88-12.16,14.32-12.16,23.29,0,4.63,1.47,8.13,4,9.61,2.09,1.21,4.8,1,7.62-.65,6.71-3.88,12.17-14.32,12.17-23.29,0-4.63-1.48-8.13-4.05-9.61A5.77,5.77,0,0,0,208.23,237.56Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.75,268.52a5,5,0,0,1-2.53-.66c-2.12-1.22-3.33-4-3.33-7.63,0-6.7,4.11-14.52,9.15-17.43,2.3-1.33,4.55-1.5,6.32-.47,2.12,1.22,3.33,4,3.33,7.63,0,6.7-4.11,14.52-9.15,17.43A7.58,7.58,0,0,1,199.75,268.52Zm7.08-25.85a6.7,6.7,0,0,0-3.29,1c-4.77,2.76-8.65,10.19-8.65,16.57,0,3.26,1,5.73,2.83,6.76,1.45.84,3.34.68,5.32-.46,4.77-2.76,8.65-10.19,8.65-16.57,0-3.26-1-5.73-2.83-6.77A4,4,0,0,0,206.83,242.67Z",
    style: {
      fill: "#092166"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.24,156.1c1.45-.84,2.58-1,3.38-.37s1.2,1.89,1.2,3.92a11.36,11.36,0,0,1-1.2,5.34,8.66,8.66,0,0,1-3.38,3.56l-2.87,1.66v6.16a1.34,1.34,0,0,1-.15.61.83.83,0,0,1-.34.42l-1.45.84a.27.27,0,0,1-.35,0,.62.62,0,0,1-.14-.45V159.91a1.47,1.47,0,0,1,.14-.61.84.84,0,0,1,.35-.42Zm-2.87,10.65,2.78-1.61a4.57,4.57,0,0,0,1.64-1.57,4.75,4.75,0,0,0,.61-2.52c0-1-.21-1.63-.61-1.79a2,2,0,0,0-1.64.35l-2.78,1.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,158.19a3.79,3.79,0,0,0-1.55,1.63,6.31,6.31,0,0,0-.48,2.67v7.19a1.33,1.33,0,0,1-.14.61.93.93,0,0,1-.34.42l-1.37.79a.25.25,0,0,1-.34,0,.59.59,0,0,1-.14-.44V158.14a1.54,1.54,0,0,1,.14-.61.9.9,0,0,1,.34-.41l1.37-.79a.26.26,0,0,1,.34,0,.57.57,0,0,1,.14.44v.64a9.81,9.81,0,0,1,1-1.6,5,5,0,0,1,1.39-1.16l.81-.47a.26.26,0,0,1,.34,0,.6.6,0,0,1,.15.45v1.82a1.34,1.34,0,0,1-.15.61.87.87,0,0,1-.34.42Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.1,150.49a3.52,3.52,0,0,1,1.79-.56,2.07,2.07,0,0,1,1.38.5,3.31,3.31,0,0,1,.93,1.4,6.67,6.67,0,0,1,.41,2.14c0,.16,0,.37,0,.63v1.53c0,.25,0,.46,0,.64a13.76,13.76,0,0,1-.41,2.61,12.49,12.49,0,0,1-.93,2.46,10.81,10.81,0,0,1-1.38,2.09,7,7,0,0,1-1.79,1.5,3.55,3.55,0,0,1-1.79.56,2.17,2.17,0,0,1-1.38-.49,3.21,3.21,0,0,1-.93-1.39,7.6,7.6,0,0,1-.41-2.14q0-.24,0-.6c0-.25,0-.5,0-.76s0-.52,0-.78,0-.48,0-.65a12.41,12.41,0,0,1,.4-2.61,13.38,13.38,0,0,1,.94-2.48,10.31,10.31,0,0,1,1.38-2.1A6.85,6.85,0,0,1,122.1,150.49Zm2.17,5a3.47,3.47,0,0,0-.26-1.27,1.27,1.27,0,0,0-.51-.61.93.93,0,0,0-.66-.07,2.68,2.68,0,0,0-.74.3,4.57,4.57,0,0,0-.74.55,3.61,3.61,0,0,0-.66.84,4.8,4.8,0,0,0-.51,1.19,6.6,6.6,0,0,0-.26,1.58,4.45,4.45,0,0,0,0,.57c0,.22,0,.46,0,.69s0,.48,0,.71a6.3,6.3,0,0,0,.29,1.79,1.18,1.18,0,0,0,.51.61,1,1,0,0,0,.66.07,3,3,0,0,0,.74-.3,4.57,4.57,0,0,0,.74-.55,3.61,3.61,0,0,0,.66-.84,5.55,5.55,0,0,0,.51-1.2,6.43,6.43,0,0,0,.26-1.57c0-.14,0-.32,0-.55V156C124.29,155.78,124.28,155.6,124.27,155.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.71,154.4a1.85,1.85,0,0,0,.3,1.2c.2.23.56.18,1.1-.13l1.1-.63a.25.25,0,0,1,.34,0,.56.56,0,0,1,.14.44v1.82a1.33,1.33,0,0,1-.14.61,1,1,0,0,1-.34.42l-1.33.77c-1.13.65-2,.73-2.6.24s-.9-1.6-.9-3.34v-5.94l-1.19.68a.26.26,0,0,1-.34,0,.6.6,0,0,1-.15-.45v-1.82a1.37,1.37,0,0,1,.15-.61.93.93,0,0,1,.34-.42l1.19-.68v-4.51a1.33,1.33,0,0,1,.14-.61.93.93,0,0,1,.34-.42l1.37-.79a.26.26,0,0,1,.34,0,.61.61,0,0,1,.14.44v4.51l2.32-1.34a.26.26,0,0,1,.34,0,.59.59,0,0,1,.14.45v1.82a1.33,1.33,0,0,1-.14.61,1,1,0,0,1-.34.42l-2.32,1.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.57,139.83a3.52,3.52,0,0,1,1.79-.56,2.07,2.07,0,0,1,1.38.5,3.33,3.33,0,0,1,.93,1.39,6.74,6.74,0,0,1,.41,2.15c0,.16,0,.37,0,.63v1.53c0,.25,0,.46,0,.63a13.12,13.12,0,0,1-.42,2.62,11.87,11.87,0,0,1-.92,2.46,10.44,10.44,0,0,1-1.38,2.08,7,7,0,0,1-1.79,1.5,3.67,3.67,0,0,1-1.79.57,2.17,2.17,0,0,1-1.38-.49,3.21,3.21,0,0,1-.93-1.39,7.33,7.33,0,0,1-.41-2.14c0-.16,0-.36,0-.61s0-.49,0-.75,0-.52,0-.78,0-.48,0-.65a12.6,12.6,0,0,1,.4-2.62,13.55,13.55,0,0,1,.94-2.47,10.31,10.31,0,0,1,1.38-2.1A6.85,6.85,0,0,1,140.57,139.83Zm2.17,5a3.58,3.58,0,0,0-.26-1.28,1.2,1.2,0,0,0-.51-.6.94.94,0,0,0-.66-.07,2.31,2.31,0,0,0-.74.3,4,4,0,0,0-.74.55,3.61,3.61,0,0,0-.66.84,5,5,0,0,0-.52,1.19,7.66,7.66,0,0,0-.26,1.58c0,.15,0,.34,0,.57s0,.45,0,.69,0,.48,0,.7,0,.4,0,.53a4,4,0,0,0,.26,1.27,1.17,1.17,0,0,0,.52.6.93.93,0,0,0,.66.08,2.72,2.72,0,0,0,.74-.31,4.33,4.33,0,0,0,.74-.54,4.24,4.24,0,0,0,.66-.85,5.26,5.26,0,0,0,.51-1.19,6.51,6.51,0,0,0,.26-1.57c0-.14,0-.32,0-.55v-1.4C142.76,145.12,142.75,144.94,142.74,144.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.18,143.74a1.85,1.85,0,0,0,.3,1.2c.2.22.56.18,1.1-.13l1.1-.63a.26.26,0,0,1,.34,0,.61.61,0,0,1,.14.44v1.83a1.5,1.5,0,0,1-.14.61,1,1,0,0,1-.34.42l-1.33.76c-1.13.65-2,.73-2.6.24s-.9-1.6-.9-3.33v-5.95l-1.19.69a.26.26,0,0,1-.34,0,.57.57,0,0,1-.15-.44v-1.83a1.33,1.33,0,0,1,.15-.6.83.83,0,0,1,.34-.42l1.19-.69v-4.51a1.32,1.32,0,0,1,.14-.6.83.83,0,0,1,.34-.42l1.37-.79a.26.26,0,0,1,.34,0,.64.64,0,0,1,.14.45v4.5l2.32-1.33a.26.26,0,0,1,.34,0,.57.57,0,0,1,.14.44v1.83a1.39,1.39,0,0,1-.14.61,1,1,0,0,1-.34.42l-2.32,1.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.76,143.79l-3.55-10.62a.5.5,0,0,1,0-.18,1.36,1.36,0,0,1,.14-.61,1,1,0,0,1,.34-.42l1.35-.78a.31.31,0,0,1,.38,0,.6.6,0,0,1,.21.31l2.39,7.17,2.39-9.92a2.44,2.44,0,0,1,.22-.57,1,1,0,0,1,.37-.44l1.35-.78a.27.27,0,0,1,.34,0,.61.61,0,0,1,.15.45,1.23,1.23,0,0,1,0,.2l-5.05,21a2.89,2.89,0,0,1-.21.57,1.06,1.06,0,0,1-.38.44l-1.35.78a.27.27,0,0,1-.34,0,.57.57,0,0,1-.14-.44,1.27,1.27,0,0,1,0-.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.55,137.45a3.26,3.26,0,0,1-1,.41,2.1,2.1,0,0,1-.78,0,1.49,1.49,0,0,1-.56-.21,1.78,1.78,0,0,1-.38-.32v5.89a1.5,1.5,0,0,1-.14.61,1,1,0,0,1-.34.42l-1.37.79a.27.27,0,0,1-.34,0,.57.57,0,0,1-.14-.44V126.45a1.39,1.39,0,0,1,.14-.61.9.9,0,0,1,.34-.41l1.37-.79a.26.26,0,0,1,.34,0,.61.61,0,0,1,.14.44v.64c.1-.22.22-.47.38-.76a6.6,6.6,0,0,1,.56-.86,6.89,6.89,0,0,1,.78-.86,4.92,4.92,0,0,1,1-.74,2.45,2.45,0,0,1,1.63-.4,2,2,0,0,1,1.24.72,4.42,4.42,0,0,1,.81,1.61,8.58,8.58,0,0,1,.33,2.25c0,.27,0,.59,0,1s0,.7,0,1a13.62,13.62,0,0,1-.33,2.64,14.49,14.49,0,0,1-.81,2.54,9.82,9.82,0,0,1-1.24,2.15A5.5,5.5,0,0,1,170.55,137.45Zm1.68-7.66a13.36,13.36,0,0,0,0-1.55c-.08-1.15-.32-1.88-.72-2.17a1.3,1.3,0,0,0-1.49.08,3.9,3.9,0,0,0-1.49,1.65,6.63,6.63,0,0,0-.69,2.7c0,.29,0,.65,0,1.07s0,.77,0,1a2.53,2.53,0,0,0,.69,1.87,1.24,1.24,0,0,0,1.49,0,4.07,4.07,0,0,0,1.49-1.64A7.61,7.61,0,0,0,172.23,129.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.16,126.75a15.45,15.45,0,0,1,.31-3.1,13.62,13.62,0,0,1,.88-2.88,10.41,10.41,0,0,1,1.39-2.4,6.32,6.32,0,0,1,1.82-1.63,3,3,0,0,1,1.83-.49,2.15,2.15,0,0,1,1.39.72,4.2,4.2,0,0,1,.89,1.73,9.12,9.12,0,0,1,.31,2.51v1.25a1.54,1.54,0,0,1-.14.61.9.9,0,0,1-.34.41l-6,3.47a2.47,2.47,0,0,0,.17,1,1.1,1.1,0,0,0,.45.55,1,1,0,0,0,.67.11,1.9,1.9,0,0,0,.77-.28,4.28,4.28,0,0,0,.94-.71,4.69,4.69,0,0,0,.59-.8,3.79,3.79,0,0,1,.32-.49,1.19,1.19,0,0,1,.34-.28l1.44-.83a.27.27,0,0,1,.35,0,.51.51,0,0,1,.14.44,5.17,5.17,0,0,1-.28,1.16,10,10,0,0,1-.78,1.64,11.15,11.15,0,0,1-1.29,1.74,7,7,0,0,1-1.77,1.43,3.2,3.2,0,0,1-1.82.52,2,2,0,0,1-1.39-.73,4.42,4.42,0,0,1-.88-1.86A11.34,11.34,0,0,1,176.16,126.75Zm4.4-6.69a3.38,3.38,0,0,0-.89.74,5.13,5.13,0,0,0-1,2,5.61,5.61,0,0,0-.17,1l4.06-2.35a5.45,5.45,0,0,0-.14-.79,1.53,1.53,0,0,0-.32-.65.83.83,0,0,0-.59-.26A1.77,1.77,0,0,0,180.56,120.06Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.19,305.4a10.19,10.19,0,0,0-1.57-2.13,19.33,19.33,0,0,0-4.36-3.37c-3.37-2-7.15-3.58-11.12-3.63a20.85,20.85,0,0,0-3.79.32,16,16,0,0,0-2,.43,4.07,4.07,0,0,0-1.25.49,6.36,6.36,0,0,1,2.26-2.67c.4-.21-.14-.75-.45-.68a4,4,0,0,0-2.15,1.85,24.34,24.34,0,0,1-1.49,2.25c-.19.21,0,.55.24.64.87.4,1.72.81,2.59,1.19.44.2.89.39,1.34.56a5.34,5.34,0,0,0,1.7.44c.52,0,.46-.53.12-.75a8.28,8.28,0,0,0-1.49-.55c-.44-.18-.87-.36-1.3-.56-.64-.28-1.27-.58-1.91-.87l.32-.48c0,.15.12.3.26.3a15.29,15.29,0,0,0,2.89-.53,19.06,19.06,0,0,1,3.2-.31,16.17,16.17,0,0,1,5.93,1,27,27,0,0,1,8.62,4.93,12.07,12.07,0,0,1,1.83,2.08c.55.8,1,1.68,1.56,2.45.1.14.39.28.46,0A3.43,3.43,0,0,0,141.19,305.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,295.13a2.64,2.64,0,0,0-.75-.66,15.86,15.86,0,0,0-.82-3.36c-.35-1-.74-2.07-1-3.12a8.35,8.35,0,0,1-.42-2.27,2.09,2.09,0,0,0,0-.56c0-.19-.38-.51-.43-.17v.07h0v0c0,.14,0,.28,0,.41a5.2,5.2,0,0,1-.31,1.06,10.59,10.59,0,0,1-.93,1.84c-.42.65-1.71,2.41-2.09.82,0-.16-.2-.33-.36-.21a13.53,13.53,0,0,0-1.24,1.27,3,3,0,0,1-.74.6c-.45.2-.51-.23-.49-.62,0-.15,0-.29,0-.4s-.27-.43-.3-.15a5.16,5.16,0,0,1-.59,2.36.64.64,0,0,1-1.05,0,2.21,2.21,0,0,1-.48-1.64c0-.09-.12-.41-.25-.27-1.44,1.49-1.33,4.08-3.07,5.31a1.52,1.52,0,0,1-.25-1.3c.06-.34-.51-.71-.64-.29a14.71,14.71,0,0,1-1.5,4c-.32.49-.91,1.14-1.58.93l-.19-.1c0-.09.09-.17.12-.25a6.9,6.9,0,0,0,.73-2.16c0-.48-.09-1.06-.66-1.15-.75-.12-1.23.68-1.35,1.3a3.49,3.49,0,0,0,.36,2.07c-.1.19-.2.38-.31.56a3.6,3.6,0,0,1-1.07,1.28c-.85.5-1.67-.57-2.54-.38-.71.15-1,.91-1.38,1.53-.17-.32-.36-.63-.52-1s-.38-.39-.58-.25a4.7,4.7,0,0,0-1.72,2.35,1.17,1.17,0,0,0-.44-.47,1,1,0,0,0-1.22.31,6.51,6.51,0,0,0-1.34,2.27c-.08-.48-.15-1-.26-1.42a5.35,5.35,0,0,0-1-2.66c-.67-.65-1.41,0-1.67.68a8.1,8.1,0,0,0-.24,3.29c0,.27.43.48.44.1a10.49,10.49,0,0,1,.23-2.5c.09-.36.21-.9.57-1.1s.39.05.52.35c.64,1.49.63,3.17,1,4.72.09.31.63.6.73.15a8.4,8.4,0,0,1,1.2-2.76c.13-.2.5-.84.79-.83s.33,1,.36,1.25.66.58.74.14a5,5,0,0,1,1.52-3,5,5,0,0,1,.52,1c.07.24.44.56.67.29a15.49,15.49,0,0,0,.88-1.39c.14-.19.33-.44.58-.47s.6.18.84.28a1.87,1.87,0,0,0,2.24-.32,6.36,6.36,0,0,0,1-1.43,1.37,1.37,0,0,0,1.63.1,4.44,4.44,0,0,0,1.66-2.3,15.57,15.57,0,0,0,.51-1.5,2.62,2.62,0,0,0,.5.66.3.3,0,0,0,.36.05c1.77-1.07,2-3.47,2.84-5.23.16.84.56,1.94,1.45,1.8.62-.1.91-.88,1.06-1.64.15.31.41.47.89.2a9.58,9.58,0,0,0,1.79-1.64c.16.39.42.77.87.77.6,0,1.11-.65,1.44-1.07a10.57,10.57,0,0,0,1.3-2.29,2.44,2.44,0,0,1,.1-.24,15.34,15.34,0,0,0,.51,1.91,43.54,43.54,0,0,1,1.37,4.61c.05.27.09.55.12.82a3.61,3.61,0,0,0-3.45.54,2.72,2.72,0,0,0,.6,4.43c1.7.7,3.14-1.39,3.41-2.82a5.63,5.63,0,0,0,.09-1.08,1.8,1.8,0,0,1,.3.26C180.87,295.86,181.26,295.49,181,295.13Zm-20,1.7a1.41,1.41,0,0,1,.46-.87.85.85,0,0,1,.23-.12,3.9,3.9,0,0,1-.35,1.39c-.08.22-.18.43-.28.65A2.56,2.56,0,0,1,160.93,296.83Zm18,.69c-.46.61-1.3,1.35-2.11,1a1.86,1.86,0,0,1-.81-2.14c.38-1.52,2.3-2.07,3.66-1.51A4.12,4.12,0,0,1,178.93,297.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6,304.43c-.27.32-.79.93-1.29.77s-.6-.71-.69-1.1-.54-.55-.73-.26c-.64,1-.84,2.42-1.86,3.06a1.24,1.24,0,0,1-1.61-.2,2.78,2.78,0,0,1-.47-1.64c0-.09,0-.2,0-.29.25-.42.49-.85.71-1.28a5.93,5.93,0,0,0,.81-2.43c0-.46-.3-1.05-.84-.83s-.89,1.2-1,1.74a10.42,10.42,0,0,0-.36,2.28v.15a7.69,7.69,0,0,1-2.1,2.47c-.49-.66-1.23-1.22-2-.73a2.23,2.23,0,0,0-.84,1h0a1.66,1.66,0,0,0-1.81.12,6.89,6.89,0,0,0-2.37,2.37,2,2,0,0,0-.81-1.05,2.27,2.27,0,0,0-2.21.12c-1.64.86-3.26,2.9-2.93,4.85,0,.28.5.49.46.1-.18-1.6,1.23-3.27,2.5-4.08a2.21,2.21,0,0,1,1.8-.48c.74.3.67,1.54.64,2.17,0,.4.74.7.78.2a5.16,5.16,0,0,1,2.09-3.12c.29-.23.94-.79,1.34-.69.17,0,.23.21.26.41a4.94,4.94,0,0,0-.1,1c0,.34.71.72.79.28a6.67,6.67,0,0,0,.09-.92,2.75,2.75,0,0,1,.49-1.24c.56-.77,1.08-.4,1.5.31a.47.47,0,0,0,.6.24,5.81,5.81,0,0,0,1.77-1.72l.21-.32a2.34,2.34,0,0,0,1.77,2.1c1.81.38,2.44-1.41,3.13-2.78a1.79,1.79,0,0,0,1,.89,1.54,1.54,0,0,0,1.78-1.06C175.16,304.61,174.8,304.2,174.6,304.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.63,278.67a10.17,10.17,0,0,1-2.13-.88,20.49,20.49,0,0,1-3.7-2.49,13.2,13.2,0,0,1-2.65-3.21,11.14,11.14,0,0,1-.75-1.65,8.3,8.3,0,0,0,2.8,1.49.52.52,0,0,0,.65-.24c.09-.27-.15-.5-.37-.59a12.33,12.33,0,0,1-3-1.77c-.93-.75-1.81-1.56-2.8-2.24-.2-.14-.64-.2-.75.11a9.31,9.31,0,0,0-.41,3.28,6.46,6.46,0,0,0,.2,1.64,1.75,1.75,0,0,0,.35.74c.27.28.49-.14.33-.24.06,0,0,.06,0,0a.3.3,0,0,0,0-.13c0-.09,0-.18,0-.27s0-.45,0-.67a14.46,14.46,0,0,1,.07-1.47,12.22,12.22,0,0,1,.26-1.9l.85.7a.46.46,0,0,0,0,.5c.67,1.08.93,2.36,1.61,3.44a14.34,14.34,0,0,0,2.81,3.3,19.42,19.42,0,0,0,4,2.54,8.24,8.24,0,0,0,1.88.73c.3.07.61.12.92.18l.39.1.14,0,.11,0c0,.09.1.19.19.16l.14-.07a.2.2,0,0,0,.09-.21C225.72,278.93,225.2,278.85,224.63,278.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.32,281.54a4.68,4.68,0,0,1-.64-.38.25.25,0,0,0-.35.12,14.61,14.61,0,0,1-3.43-1.57l-.54-.31a27.79,27.79,0,0,1,1.75-3.7c.27-.47-.66-.87-.93-.41a28.09,28.09,0,0,0-1.79,3.55,14,14,0,0,0-2.93-1.33c-.43-.13-.5.45-.19.65l2.69,1.7-.29.69c-.36.86-.72,1.72-1.13,2.57-.19.4-.4.79-.61,1.19s-.34.65-.06,1.05c.06.09.19.21.31.17.82-.25,1.15-1.34,1.49-2.06s.73-1.68,1.07-2.54c.07-.15.13-.31.19-.47l.86.52a17.74,17.74,0,0,0,2.08,1.07,4.74,4.74,0,0,0,2.32.51A.54.54,0,0,0,239.32,281.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,255.84c0-.31-.53-.48-.49-.07a2.45,2.45,0,0,1-1.22,2.4,4.2,4.2,0,0,1-2.75-.42,15.62,15.62,0,0,1-2.93-1.61c0-.29-.09-.58-.15-.83-.52-2.34-1.87-5.1-4.34-5.83a.4.4,0,0,0-.48.14,2.8,2.8,0,0,0,.33,2.82,13.25,13.25,0,0,0,2.85,3.26c.3.25.6.5.92.74a6.43,6.43,0,0,1-.17,2.32,2.41,2.41,0,0,1-1,1.48,2,2,0,0,1-1.39.21,3.19,3.19,0,0,0,.44-1.42,2.86,2.86,0,0,0-2.51-2.71c-1.25-.2-1.85.87-1.6,2a3.67,3.67,0,0,0,2.23,2.48,3,3,0,0,1-.85.6l-.05-.07a1.09,1.09,0,0,0-.85-.42c-.25,0-.48.13-.39.41a1.33,1.33,0,0,0,.23.41,16.55,16.55,0,0,1-2.17,2.33,3.44,3.44,0,0,1-1.55,1c-.46,0-.4-.72-.39-1.09s-.58-.8-.84-.38c-.77,1.23-.75,2.8-1.51,4a7.21,7.21,0,0,1-1.63-2.52c-.12-.29-.8-.47-.91-.08a15.17,15.17,0,0,1-1,3.19c-.19.36-.5.83-1,.83a1.55,1.55,0,0,1-1.16-.73l0-.06a6.12,6.12,0,0,0,.79-2.57,6.27,6.27,0,0,0-1.12-3.62.63.63,0,0,0-.67-.28c-2.29.53-1.16,4.08-.56,5.48a7.56,7.56,0,0,0,.45.9l-.15.29a16.41,16.41,0,0,1-3.1,4.39,9.14,9.14,0,0,1-.91-1.38c-.13-.22-.54-.43-.78-.23a5.5,5.5,0,0,0-1.74,3,1.65,1.65,0,0,0-.27-.19,1.24,1.24,0,0,0-1.38.36,5.69,5.69,0,0,0-1.28,2.26c-.14-.52-.24-1.06-.39-1.51-.25-.77-.61-1.74-1.47-2-2-.56-2.06,2.61-1.6,3.77.14.35.78.43.61,0a3.7,3.7,0,0,1-.07-1.87c.08-.47.57-1.69,1.2-1a5.5,5.5,0,0,1,.8,2.29,5.5,5.5,0,0,0,.73,2c.2.27.79.33.85-.09a7.14,7.14,0,0,1,1-2.56c.13-.23.42-.76.71-.83l0,0s0,0,.05.08a2.09,2.09,0,0,1,.33.82c.11.41,1,.64,1,.08a5.78,5.78,0,0,1,1.22-3.43,5.61,5.61,0,0,0,1.18,1.44.54.54,0,0,0,.61,0,15.44,15.44,0,0,0,3.56-4.77,3.05,3.05,0,0,0,.72.55,1.89,1.89,0,0,0,2.61-.66,7.4,7.4,0,0,0,.9-2.37,8.39,8.39,0,0,0,1.74,2,.52.52,0,0,0,.68,0,8.05,8.05,0,0,0,1.3-3.26,1.11,1.11,0,0,0,.55.44,2.12,2.12,0,0,0,1.9-.54,14.28,14.28,0,0,0,3-3.05,2,2,0,0,0,1.21-.33,3.67,3.67,0,0,0,.82-.71,3.18,3.18,0,0,0,2.63-.25,4.11,4.11,0,0,0,1.41-3.75A16.15,16.15,0,0,0,275,258.4a5.89,5.89,0,0,0,3.56.65,2,2,0,0,0,1.34-.94A3.46,3.46,0,0,0,280,255.84Zm-27.6,9.23c-.12-.65-.27-1.81.31-2.3a5.24,5.24,0,0,1,.73,2.89,4.71,4.71,0,0,1-.4,1.48A9.33,9.33,0,0,1,252.44,265.07Zm13.89-7.2c.07-1.24,1.46-.73,2-.14a1.91,1.91,0,0,1-.1,2.47A2.56,2.56,0,0,1,266.33,257.87Zm2.89-5c-.47-.64-1.11-1.65-.84-2.48a5.92,5.92,0,0,1,2.75,3.41,10.74,10.74,0,0,1,.47,1.55A13.56,13.56,0,0,1,269.22,252.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,98.6c-.89-1.92-2.13-3.72-3.2-5.54-1.47-2.5-2.14-4.32-2-4.55.48-.84,1.82-3.43,2.78-5,.8-1.28,2.17-3.59,1.81-5.17-.14-.63-1.48-.5-2.17-.26-1.73.61-3.41,1.38-5.15,2-1.19.39-3.16,1.22-3.36,1.18-.54-.09-3.48-2.6-4.64-3.62A26.54,26.54,0,0,0,235,74.76c-.51-.32-1,.83-1,1.5a68.19,68.19,0,0,0,.38,8.81l-.67.21c-1.91.61-9.93,3.81-9.3,4.66,1,1.38,3.94,2.69,5.38,3.18a50.8,50.8,0,0,0,5,1.49c.61,2.71-1.14,8.44.24,11a1.59,1.59,0,0,0,2.28.77,15.72,15.72,0,0,0,3-3.48c1-1.36,3-4.5,4.1-4.91,1.41-.52,3.31.63,4.6,1.14a9.79,9.79,0,0,0,4.87.91C254.78,100,255,99.3,254.66,98.6Zm-11.43-2.9c-2.26.74-4.76,5.76-6.42,7.49-.23-1.21.32-5.42.23-6.63-.1-1.48.42-3.36-1.15-4-2-.82-4.17-1.17-6.19-1.94-.5-.19-1-.39-1.49-.63l-.08,0a5.71,5.71,0,0,1,1.15-.66,50.72,50.72,0,0,1,5.87-2,.76.76,0,0,0,.54-1.07.52.52,0,0,0,.2-.45c.05-2.61-.11-5.21-.06-7.82a85.53,85.53,0,0,0,7.23,5.89s6-2.27,8.4-3.26c-.52,1-1.75,2.75-2.32,3.75-.85,1.5-2.31,4.19-2.31,4.19,0,.63,1,2.61,2.15,4.7.74,1.4,1.85,3.18,2.7,4.53C248.84,97.21,246.2,94.74,243.23,95.7Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.9,98.82c-.53,7.22-6.49,13.64-12.54,17a30,30,0,0,1-11.19,3.43,38.22,38.22,0,0,1-6,.23c-1,0-2.06-.15-3.09-.24a3.08,3.08,0,0,0,1.66-1.59c.13-.33-.18-1.08-.63-.85-.63.31-1.2.74-1.84,1a7.12,7.12,0,0,1-1.69.49c-1.14.18-2.29.28-3.41.55-.79.18-.67,1.2,0,1.48,1.51.64,3,1.17,4.54,1.84.67.3,1.32.62,2,1a18.5,18.5,0,0,0,2.06,1.21.58.58,0,0,0,.7-.21c.17-.28,0-.51-.09-.77a2.88,2.88,0,0,0-1-1c-.25-.18-.52-.35-.78-.51-.59-.35-1.2-.66-1.82-1-.28-.14-.57-.25-.85-.37a33.64,33.64,0,0,0,11.45.19,30.13,30.13,0,0,0,11.66-3.88c6.1-3.63,12.12-10.35,11.77-17.86C229.65,98.6,229,98.13,228.9,98.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229,192.35c1.74-3.25,4.92-7.18,3.1-11-1.37-2.88-4.85-3.8-7.78-3.79-.25,0-.25.55,0,.56,3,.08,7.38,1.3,7.62,4.91.14,2.13-1.24,3.92-2.29,5.65a63,63,0,0,0-3.16,5.83,16.53,16.53,0,0,0-1.85,5.66c-.1,1.36.72,3.26,2.42,2.82.56-.14.24-1-.23-1.11-.63-.09-1-.07-1.08-.77a6.27,6.27,0,0,1,.44-2.52A36.58,36.58,0,0,1,229,192.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.94,179.5c-1.49-3-3.93-5.55-5.86-8.25-.62-.86-1.58-1.88-2.22-3a4.44,4.44,0,0,0-.8-2.85c-.18-.24-.68-.38-.71.06a5,5,0,0,0,.57,2.62,13.72,13.72,0,0,1-.42,2.25,10,10,0,0,1-2.05,4.3c-1.58,1.71-4,.37-5.32-1.56,0-1.45,0-3.19-1-4.28-.19-.21-.43-.19-.54.08-.57,1.43,0,3,.89,4.37,0,.38-.06.74-.09,1a23.06,23.06,0,0,1-.6,3.78,4.2,4.2,0,0,1-.49-.68c-.06-.11-.23-.21-.34-.12-1.36,1-1.1,2.73-1.3,4.25a17.88,17.88,0,0,1-.62-1.83c-.08-.27-.48-.55-.62-.15-1,2.85.37,6-.36,8.92-.43,1.68-1.94,2.49-3.37,1.24l-.21-.2c.48-1.64.51-3.59-.26-4.46-.17-.19-.41-.21-.51.05a3.43,3.43,0,0,0-.21,1.16c-.25-.53-.47-1.09-.76-1.6-.14-.26-.53-.36-.63,0-.35,1.32.35,3.6,1.54,5.15-.38.92-1.12,2.11-2,1-.25-.33-.54,0-.53.28a18.58,18.58,0,0,1-.15,3.73,3.16,3.16,0,0,1-.66,1.7c-.85.95-1.57.23-1.79-.82-.09-.46-.65-.45-.62.05.09,1.73-.53,4.65-2,5.72a1.24,1.24,0,0,1-1.4.23c.59-1.93.82-4.16-.26-5.77-.07-.11-.27-.22-.38-.11-1.25,1.2-1.57,4.83-.15,6.29-.17.47-.35.92-.52,1.3-.9,2-2.62,4.76-5.19,4.45-.24,0-.25.51,0,.55,2.79.41,4.78-2.56,5.78-4.77.15-.35.31-.74.45-1.14a2.07,2.07,0,0,0,.8.23c2.33.16,3.32-3.23,3.53-5.57.64.82,1.64,1.07,2.49-.18s.89-3.36.82-5c.9.54,1.75-.29,2.31-1.58,1,1,2.26,1.48,3.53.63,1.43-1,1.47-3.08,1.47-4.61s-.46-3.58-.3-5.3a7,7,0,0,0,.74,1.63c.12.18.42.22.49,0,.36-1.41-.12-3.44,1-4.54.21.29.44.54.64.84s.37.22.45,0a16.47,16.47,0,0,0,.91-4.89,4.19,4.19,0,0,0,.26.33c1.18,1.35,3.25,3,5.08,1.85s2.62-3.43,3.05-5.27c.11-.46.21-1,.29-1.51.51.74,1.08,1.45,1.56,2.15,1.95,2.82,4.07,5.52,6.08,8.3C269.79,180.53,270.18,180,269.94,179.5ZM234,196.92a6.23,6.23,0,0,1,0,4.34A5,5,0,0,1,234,196.92Zm9.79-8.9a.32.32,0,0,0,.34.11c-.06.28-.12.55-.19.8a5.7,5.7,0,0,1-1.17-2.56A6,6,0,0,0,243.78,188Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,182.6a1.69,1.69,0,0,0-.23-.84c-.09-.15-.2-.3-.31-.45a8.48,8.48,0,0,0-.86-.94,8.65,8.65,0,0,0-1.68-1.19c-.68-.38-1.39-.7-2.09-1,.35-.17.7-.37,1-.57a10.88,10.88,0,0,1,3-1.63c.46-.11.1-1-.29-1a6.25,6.25,0,0,0-3.07,1,9.06,9.06,0,0,1-2.79,1.28c-.74.14-.33,1,.1,1.3,1.13.66,2.36,1.11,3.51,1.72a6.9,6.9,0,0,1,1.42,1,5.15,5.15,0,0,1,.61.63l.29.39a5.76,5.76,0,0,0,.59.62C227.54,183.19,228.09,183.13,228,182.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.37,344.52a6,6,0,0,0-2.13-2.88,11,11,0,0,0-3.41-1.83,16.39,16.39,0,0,0-8.1-.66,10.51,10.51,0,0,0-3.87,1.42.78.78,0,0,0-.16.15l-.28-.25a8.3,8.3,0,0,1,.64-1,3.82,3.82,0,0,1,.71-.79l.25-.16a1,1,0,0,0,.14-.08c.11-.1,0-.13.17-.11s.15-.26,0-.31a1,1,0,0,0-.91-.09,2.9,2.9,0,0,0-.93.74,7.23,7.23,0,0,0-1.1,1.62.43.43,0,0,0,.14.49,16.91,16.91,0,0,0,1.54,1.26l.86.62a2.48,2.48,0,0,0,1.25.63.21.21,0,0,0,.21-.16c.12-.49-.66-.86-1-1.08s-.56-.39-.83-.6l-.08-.05a12.13,12.13,0,0,1,6.53-1.48,13.56,13.56,0,0,1,7.06,2,8.07,8.07,0,0,1,1.41,1.12,11.11,11.11,0,0,1,1.2,1.64C133.9,344.85,134.46,344.94,134.37,344.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.41,337.52c-.31.49-.4,1.06-.68,1.56-.08.14-.21.38-.37.43s-.57-.31-.72-.49-.6-.35-.76,0a4.88,4.88,0,0,0-.39,1.15,2.14,2.14,0,0,1-.17-.3c-.14-.31-.89-.42-.89,0a5.17,5.17,0,0,1-1,2.75c-.36.53-1.09,1.5-1.82,1.44s-1-1.49-1-2.12a6.54,6.54,0,0,1,.63-2.88c.46-1,1.26-1.72,2.34-1.13.37.2.38-.34.12-.5-2.62-1.64-4,2.19-4,4.17a3.43,3.43,0,0,0,1.33,3.08c1,.56,2.1-.16,2.78-.92a6.46,6.46,0,0,0,1.42-2.66l.19.23c.21.28.75.27.82-.11a11.6,11.6,0,0,1,.27-1.33c.48.37,1.06.6,1.58.15a3.36,3.36,0,0,0,.89-2.25C147,337.52,146.57,337.26,146.41,337.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.81,336.76c-.24-.1-.53-.13-.76-.21a4.37,4.37,0,0,1-.69-.33c-.15-.09-.38,0-.34.21a2.75,2.75,0,0,1,0,.86l0-.09v0s0-.05,0-.08-.06-.24-.08-.36a.37.37,0,0,0-.3-.3c-.16,0-.2.14-.18.26a2.16,2.16,0,0,0,.74,1.48c.15.12.4.11.4-.14a8.07,8.07,0,0,1,.12-1.09l.34.17a2,2,0,0,0,.95.17c.12,0,.15-.15.13-.24A.37.37,0,0,0,150.81,336.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.48,327.56c-.8.32-.8,1-1.29,1.62s-1.11-.14-1.8.16a1.87,1.87,0,0,0-.7.67c-.13.18-.41.8-.68.75s-.54-.71-.65-.9a4.83,4.83,0,0,0-.55-.86c-.17-.19-.63-.36-.77,0a6.36,6.36,0,0,0-.38,1.78l-.08-.21a.57.57,0,0,0-.92-.19,1.65,1.65,0,0,0,.25,2.31,6.4,6.4,0,0,1-.3,1.52c-.31.89-1,2.19-2.18,2-2.27-.45-2-4-1.63-5.6.18-.88.62-2.51,1.76-2.57.48,0,.22-.66-.15-.67-1.26,0-1.93,1.15-2.28,2.21a9.82,9.82,0,0,0-.37,4.31,3.4,3.4,0,0,0,2.07,2.95,2.6,2.6,0,0,0,3.31-1.35,6.46,6.46,0,0,0,.77-2.34.39.39,0,0,0,.21-.19,9.6,9.6,0,0,0,.55-2.75,3.54,3.54,0,0,0,.86,1.13c.72.53,1.33.08,1.75-.55.2-.31.41-.77.82-.67s.6.26,1,.15a1.53,1.53,0,0,0,1-.76c.26-.46.34-1,.87-1.21S164.87,327.41,164.48,327.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.59,328c-.44,0,0,.69.33.66S168,327.94,167.59,328Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.64,352.24a6.27,6.27,0,0,0-1.21-3.73,21.47,21.47,0,0,0-2.87-3.69,12.08,12.08,0,0,0-3.88-2.4c-1.52-.62-3.23-.68-4.7-1.37-1-.48-1.31.89-.41,1.31a22.83,22.83,0,0,0,3.54.95,11.72,11.72,0,0,1,3.88,1.87,12.48,12.48,0,0,1,2.42,2.75A8.09,8.09,0,0,1,108,351c-2.2-1-4-2.67-6.62-2.46-.52,0-.47.73-.24,1,1.27,1.58,3.18,2.32,4.55,3.76a7.81,7.81,0,0,1,2.16,5.51c-1.85-.68-3.1-2.09-5.31-1.46-.57.16-.14.95.13,1.16a11.08,11.08,0,0,1,4.34,7.64,20.25,20.25,0,0,0-5.54-3.24c-1.25-.47-2.53-.88-3.79-1.36s-2.33-1.11-3.57-1.48c-.34-.11-.58.17-.58.49a7.87,7.87,0,0,0,1.31,4.77c.27.39.56.76.8,1.17a1.36,1.36,0,0,0,.27.38h-.1a9.66,9.66,0,0,1-2.93-.75,15.53,15.53,0,0,1-5-3,29.16,29.16,0,0,1-4.41-4.19c-.17-.24-.66-.42-.91-.18-1.48,1.46-.5,3.77-.68,5.63-2.77-1.69-3-5.67-3.09-8.54a11.64,11.64,0,0,1,.85-4.18,1.31,1.31,0,0,0,.12-.61c0-.21-.2-.42-.41-.4s-.35.25-.44.44a16.28,16.28,0,0,0-1,2.66,12,12,0,0,0-.16,2.4,11.58,11.58,0,0,0,.43,3.75c.64,2.18,1.83,5,4.09,5.87a.41.41,0,0,0,.54-.24c.34-1.42-.42-3.82.33-5.18a34.28,34.28,0,0,0,4.62,4.32,16.43,16.43,0,0,0,6.28,3.2c.79.21,3.47,1.17,3.22-.53a6.19,6.19,0,0,0-1.4-2.43,5.87,5.87,0,0,1-1.13-3.32c1,.38,1.89.88,2.87,1.25,1.19.45,2.41.85,3.6,1.3a21.72,21.72,0,0,1,6.2,3.88c.26.22.92.22.93-.25a12.83,12.83,0,0,0-3.94-9.17c1.37.2,2.56,1.34,3.92,1.72.35.09.67,0,.76-.36.5-2.14-.5-4.5-1.64-6.27-1-1.61-2.69-2.44-4.07-3.59,1.89.48,3.57,2.05,5.39,2.65A.58.58,0,0,0,109.64,352.24Z",
    style: {
      fill: "#ebebeb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rocket--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--rocket--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.42,252.38l-33.23-12.24a32.23,32.23,0,0,1,.14-4.26c0-.44.09-.86.15-1.28s.13-.81.21-1.2.18-.79.29-1.17c0-.19.12-.38.18-.57s.08-.29.13-.43h0a9.75,9.75,0,0,1,4.36-5.46l4.26-2.45.46-.27a12.23,12.23,0,0,1,4.35-1.38,39.76,39.76,0,0,0,9.5-2.28,12,12,0,0,0,2.4-2.68c3.24-5,4.06-15.59,3.85-20.88l4.72-2.73,2.93,56.56-4.95-1.83V248Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.19,240.14l33.23,12.24-.24-4.4v-.15l-1.76-34-.94-18c.21,5.29-.61,15.93-3.85,20.88a12,12,0,0,1-2.4,2.68c-3.28,2.74-8.16,4.19-14.21,5a14,14,0,0,0-1.82.35,11.06,11.06,0,0,0-2.54,1,9.75,9.75,0,0,0-4.36,5.46h0c-.05.14-.09.29-.13.43s-.13.38-.18.57c-.11.38-.21.77-.29,1.17s-.15.79-.21,1.2-.12.84-.15,1.28A32.23,32.23,0,0,0,367.19,240.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.92,242.88l-31.63-11.64a19.36,19.36,0,0,0-1,4.64L400.19,248Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.92,242.88l-31.63-11.64a19.36,19.36,0,0,0-1,4.64L400.19,248Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.48,252.38l33.23-12.24a34,34,0,0,0-.14-4.26c0-.44-.09-.86-.15-1.28s-.13-.81-.21-1.2-.19-.79-.29-1.17l-.18-.57c-.05-.14-.09-.29-.14-.43h0a9.69,9.69,0,0,0-4.35-5.46L457,223.32l-.45-.27a12.28,12.28,0,0,0-4.36-1.38,39.67,39.67,0,0,1-9.49-2.28,12.28,12.28,0,0,1-2.41-2.68c-3.24-5-4.05-15.59-3.84-20.88l-4.73-2.73-2.93,56.56,4.95-1.83V248Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.71,240.14l-33.23,12.24.23-4.4v-.15l1.77-34,.94-18c-.21,5.29.6,15.93,3.84,20.88a12.28,12.28,0,0,0,2.41,2.68c3.28,2.74,8.16,4.19,14.21,5a13.82,13.82,0,0,1,1.81.35,11.14,11.14,0,0,1,2.55,1,9.69,9.69,0,0,1,4.35,5.46h0c0,.14.09.29.14.43l.18.57c.1.38.2.77.29,1.17s.15.79.21,1.2.11.84.15,1.28A34,34,0,0,1,466.71,240.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,242.88l31.64-11.64a19.37,19.37,0,0,1,1,4.64L433.71,248Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,242.88l31.64-11.64a19.37,19.37,0,0,1,1,4.64L433.71,248Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.57,293.08h0l-5.32-18.86H398.71l-5.32,18.86h0c-.75,3.84,1.4,7.83,6.5,10.77,8.88,5.13,23.28,5.13,32.16,0C437.16,300.91,439.32,296.92,438.57,293.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 415.99,
    cy: 274.86,
    rx: 17.33,
    ry: 7.99,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.22,284.68l-1.2-4.23a13.27,13.27,0,0,1-4.71,4.26c-7.91,4.57-20.74,4.57-28.64,0a13.31,13.31,0,0,1-4.72-4.26l-1.19,4.23c.17,2.86,2.13,5.69,5.91,7.87,7.9,4.56,20.73,4.56,28.64,0C434.09,290.37,436.05,287.54,436.22,284.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.57,293.08l-.05-.25-.58-2.05c.08,3.07-1.94,6.22-6.09,8.62-8.76,5.05-23,5.05-31.72,0C396,297,394,293.85,394,290.77l-.58,2.07,0,.24c-.75,3.84,1.4,7.83,6.5,10.77,8.88,5.13,23.28,5.13,32.16,0C437.16,300.91,439.32,296.92,438.57,293.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.73,274.22h-3c1,4.28,3.6,21.93,3.94,24.54.42,3.22-6.72,8.65-25.51,7.64,8.46,2.33,18.89,1.49,25.89-2.55a16,16,0,0,0,4.59-3.81Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.65,162.75c0-49.12-20.75-91.57-36.18-101.4l-.42-.27L419,61h0a6,6,0,0,0-6,0h0l-.07,0-.42.27c-15.43,9.83-36.18,52.28-36.18,101.4,0,47.27,13.25,101.16,14.51,105.05,0,.1.07.2.1.3h0c1,2.74,3.28,5.36,7,7.49,10,5.77,26.17,5.77,36.16,0,3.82-2.2,6.17-4.94,7.07-7.79C442.4,263.9,455.65,210,455.65,162.75Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.65,162.75c0-49.12-20.75-91.57-36.18-101.4l-.42-.27L419,61h0a6,6,0,0,0-6,0h0l-.07,0-.42.27c-15.43,9.83-36.18,52.28-36.18,101.4,0,47.27,13.25,101.16,14.51,105.05,0,.1.07.2.1.3h0c1,2.74,3.28,5.36,7,7.49,10,5.77,26.17,5.77,36.16,0,3.82-2.2,6.17-4.94,7.07-7.79C442.4,263.9,455.65,210,455.65,162.75Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.75,73.16c-3.82-5.48-7.7-9.53-11.28-11.81l-.41-.27L419,61h0a6,6,0,0,0-6,0h0l-.08,0-.41.27c-3.58,2.29-7.46,6.33-11.3,11.82a99.92,99.92,0,0,0-6.61,11c.68,2.54,2.7,5,6.09,6.92,8.45,4.89,22.15,4.89,30.6,0,3.38-2,5.41-4.38,6.08-6.92A96.21,96.21,0,0,0,430.75,73.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.33,162.75c0,47.27,13.25,101.16,14.51,105.05,0,.1.07.2.1.3h0c1,2.74,3.28,5.36,7,7.49a28.84,28.84,0,0,0,5.57,2.42C397,254.78,389.43,203.32,389.43,164c0-54.43,13.4-93,23.08-102.6C397.08,71.18,376.33,113.63,376.33,162.75Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.65,162.75c0,47.27-13.25,101.16-14.51,105.05,0,.1-.07.2-.1.3h0c-1,2.74-3.29,5.36-7,7.49,7.48-27.38,16-72.27,16-111.64,0-54.43-21-93-30.64-102.6C434.9,71.18,455.65,113.63,455.65,162.75Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.4,266.69,366,296.09l-4.95-2.23c-1.24-9.55,1-18.33,7-28,2.55-4.11,4.89-7.93,7-11.53a116.92,116.92,0,0,0,8-16.06c3.18-8.27,3.66-13.26,3-18.67a3.08,3.08,0,0,0-.06-.54c0-.19,0-.36-.07-.52l2.61,1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.12,283.66a35.22,35.22,0,0,0-.36,5.81l4.93,2.22v-.15a37.67,37.67,0,0,1,.36-5.63v0Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.12,283.66a35.22,35.22,0,0,0-.36,5.81l4.93,2.22v-.15a37.67,37.67,0,0,1,.36-5.63v0Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.61,219.54c.71,5,.53,11.18-1.81,20.17-2.14,8.24-7.06,17.64-13.77,28.42-6,9.63-8.25,18.41-7,28L396.4,266.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,257.88l-28.94,28a36.48,36.48,0,0,0-.37,5.82l30.06-29.08Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.58,266.69,466,296.09l5-2.23c1.24-9.55-1-18.33-7-28-2.55-4.11-4.89-7.93-7-11.53a116.92,116.92,0,0,1-8-16.06c-3.18-8.27-3.66-13.26-3-18.67a3.08,3.08,0,0,1,.06-.54c0-.19,0-.36.07-.52l-2.61,1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.86,283.66a35.22,35.22,0,0,1,.36,5.81l-4.93,2.22v-.15a36.39,36.39,0,0,0-.37-5.63v0Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.86,283.66a35.22,35.22,0,0,1,.36,5.81l-4.93,2.22v-.15a36.39,36.39,0,0,0-.37-5.63v0Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.37,219.54c-.72,5-.53,11.18,1.8,20.17,2.15,8.24,7.06,17.64,13.78,28.42,6,9.63,8.25,18.41,7,28L435.58,266.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,257.88l28.94,28a36.48,36.48,0,0,1,.37,5.82l-30.06-29.08Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,63a.47.47,0,0,1-.47-.47v-23a.47.47,0,1,1,.94,0v23A.47.47,0,0,1,416,63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.29,39.51a3.3,3.3,0,1,1-3.3-3.3A3.3,3.3,0,0,1,419.29,39.51Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415.99,
    cy: 136.57,
    r: 17.37,
    transform: "translate(229.61 532.76) rotate(-82.98)",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 415.99,
    cy: 136.57,
    r: 17.37,
    transform: "translate(229.61 532.76) rotate(-82.98)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Scissors--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--scissors--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.12,402.83l58.36-12.93.13,1.58s-1.25,2.13-14.89,6.16-47.36,11.17-47.36,11.17L129,406.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,377a40.28,40.28,0,0,1-7.54,8.66c-4.08,3.21-25.92,22.14-25.92,22.14l-7,3.91-2.11-1.23,3.17-7.39s24.67-17.49,30-21.15S176.71,375.94,176,377Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.41 408.71 135.52 409.94 134.97 411.34 133.41 410.43 133.41 408.71",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.09 375.05 176.09 376.81 174.32 379.38 174.32 376.67 176.09 375.05",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.92,430.85c2.71-4.21-.45-8.22-.15-11.85s.8-11.25.8-11.25l-7,3.91s-2.34,6-3.31,8.5-5.19,5.18-7.76,7.35-4.75,7.37,2.46,9.4S139.2,435.06,141.92,430.85Zm-12.69,3.24c-2.77-.81-3.61-3.09-1.86-5.1a8.62,8.62,0,0,1,8.2-2.19c2.78.81,3.61,3.09,1.86,5.1A8.59,8.59,0,0,1,129.23,434.09Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.92,430.85c2.71-4.21-.45-8.22-.15-11.85s.8-11.25.8-11.25l-7,3.91s-2.34,6-3.31,8.5-5.19,5.18-7.76,7.35-4.75,7.37,2.46,9.4S139.2,435.06,141.92,430.85Zm-12.69,3.24c-2.77-.81-3.61-3.09-1.86-5.1a8.62,8.62,0,0,1,8.2-2.19c2.78.81,3.61,3.09,1.86,5.1A8.59,8.59,0,0,1,129.23,434.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,405.11a3,3,0,0,1-2.9.56c-1.07-.31-1.5-1.06-1-1.68a3.06,3.06,0,0,1,2.9-.55C142.31,403.75,142.74,404.5,142.2,405.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.09,402s-8.34,1.54-11.09,1.8-6.71-.33-13.58.29-19.24,6.52-19.87,12.24,5.29,6.14,9.55,5.11,6.61-2.59,13.9-6.24c9.74-4.86,16.2-7.95,16.2-7.95l5.45-4.51Zm-16.15,7.71a86.47,86.47,0,0,0-11.59,4.69c-4.65,2.3-5.77,3.86-8.68,4.54-2.36.56-4.7-.77-3.51-3.36,1.27-2.77,4.76-5.63,11.2-7.74s11.7-1.72,14-.48C120.31,407.83,120.75,408.78,117.94,409.7Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.09,402s-8.34,1.54-11.09,1.8-6.71-.33-13.58.29-19.24,6.52-19.87,12.24,5.29,6.14,9.55,5.11,6.61-2.59,13.9-6.24c9.74-4.86,16.2-7.95,16.2-7.95l5.45-4.51Zm-16.15,7.71a86.47,86.47,0,0,0-11.59,4.69c-4.65,2.3-5.77,3.86-8.68,4.54-2.36.56-4.7-.77-3.51-3.36,1.27-2.77,4.76-5.63,11.2-7.74s11.7-1.72,14-.48C120.31,407.83,120.75,408.78,117.94,409.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.36 408.81 130.36 407.09 129.2 405.52 129.2 407.24 130.36 408.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.12,401.11l58.49-11.35s-1.25,2.13-14.89,6.16-47.36,11.17-47.36,11.17L129,405.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,375.23a40.28,40.28,0,0,1-7.54,8.66C164.41,387.1,142.57,406,142.57,406l-7,3.91-2.11-1.23,3.17-7.39s24.67-17.49,30-21.15S176.71,374.22,176,375.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.92,429.13c2.71-4.21-.45-8.22-.15-11.85s.8-11.25.8-11.25l-7,3.91s-2.34,6-3.31,8.5-5.19,5.18-7.76,7.35-4.75,7.37,2.46,9.4S139.2,433.35,141.92,429.13Zm-12.69,3.24c-2.77-.81-3.61-3.09-1.86-5.1a8.62,8.62,0,0,1,8.2-2.19c2.78.81,3.61,3.09,1.86,5.1A8.59,8.59,0,0,1,129.23,432.37Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,403.39a3,3,0,0,1-2.9.56c-1.07-.31-1.5-1.06-1-1.68a3.06,3.06,0,0,1,2.9-.55C142.31,402,142.74,402.78,142.2,403.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.09,400.27s-8.34,1.54-11.09,1.8-6.71-.33-13.58.29-19.24,6.52-19.87,12.24,5.29,6.14,9.55,5.12,6.61-2.6,13.9-6.25c9.74-4.86,16.2-8,16.2-8l5.45-4.51ZM117.94,408a86.47,86.47,0,0,0-11.59,4.69c-4.65,2.3-5.77,3.86-8.68,4.54-2.36.56-4.7-.77-3.51-3.36,1.27-2.77,4.76-5.63,11.2-7.74s11.7-1.72,14-.48C120.31,406.11,120.75,407.06,117.94,408Z",
    style: {
      fill: "#092166"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pencil--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.18,311.27l15.83-3.1a.49.49,0,0,1,.47.8l-10.74,12.17Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.48,309a.49.49,0,0,0-.47-.8l-3.09.6h0a2.72,2.72,0,0,1,1.28,2.53l0,.27Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.13,355.31l1.29-.74,1.57-.9,56.75-32.53a7.2,7.2,0,0,0-.45-5.25c-1.12-2.52-3.3-4.5-5.11-4.62l-56.71,32.52-3,1.72C207.48,344.5,213.12,354.28,211.13,355.31Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.13,355.31l1.29-.74,1.57-.9,56.75-32.53a7.2,7.2,0,0,0-.45-5.25c-1.12-2.52-3.3-4.5-5.11-4.62l-56.71,32.52-3,1.72C207.48,344.5,213.12,354.28,211.13,355.31Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.07,352.5l2.89-1.67c.85-.45.36-2.55-.64-4.72-1.31-2.88-3.91-5.67-5-5.07l-2.13,1.22-.75.45c1.13-.6,3.73,2.19,5.05,5.08,1,2.07,1.44,4.1.72,4.65h0A.24.24,0,0,1,216.07,352.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.79,352.07c2-1.05-3.7-10.83-5.69-9.78L208.21,344c2-1.06,7.66,8.73,5.68,9.78Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.13,355.31l2.86-1.64c2-1-3.45-10.5-5.52-9.88l-.11,0-2.87,1.67C207.48,344.5,213.12,354.28,211.13,355.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.55,308.44l-.54-.27-11.49,6.28-60,34.4c-.11-.18-.2-.19-.27-.07,1.69,2.64,3,6,1.85,6.53l1.29-.74,1.57-.9,56.75-32.53h0L281.48,309A.48.48,0,0,0,281.55,308.44Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,362.25l12.14-6.94c.85-.44.38-2.52-.6-4.68-1.31-2.88-3.9-5.7-5-5.12h0l-12.17,7c-2.42,1.4-.2,6.65,2.5,9A2.89,2.89,0,0,0,199,362.25Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.72,358.49c-.7-2.74-2.92-5.42-4.95-6a2,2,0,0,0-1.82.24c-1.83,1.7.3,6.52,2.85,8.74a2.94,2.94,0,0,0,3.13.8C199.84,361.74,200.19,360.34,199.72,358.49Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screwdriver--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--screwdriver--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.14,408.14l7.52,13,25.39-14.66c1-.52,1.7-1.74,1.7-3.51a11.78,11.78,0,0,0-5.32-9.23,3.76,3.76,0,0,0-3.77-.37h0Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.63,410.84h0c-.11,2-2.92,2.41-2.92,2.41l5.33,9.23s1.77-2.19,3.55-1.33h0c2.63,1.13,4.66-.27,4.66-3.41a11.76,11.76,0,0,0-5.33-9.22C221.19,406.94,219,408,218.63,410.84Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.63,410.84h0c-.11,2-2.92,2.41-2.92,2.41l5.33,9.23s1.77-2.19,3.55-1.33h0c2.63,1.13,4.66-.27,4.66-3.41a11.76,11.76,0,0,0-5.33-9.22C221.19,406.94,219,408,218.63,410.84Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,412.85a5.45,5.45,0,0,1-1.28.39l5.33,9.23a5.52,5.52,0,0,1,1-.9A11.9,11.9,0,0,0,217,412.85Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.16,413.9l.45.77a5.53,5.53,0,0,0-.23,1.65,11.77,11.77,0,0,0,5.32,9.22,5.62,5.62,0,0,0,1.55.63l.44.77,1.78-1h0a3.76,3.76,0,0,0,1.56-3.45,11.79,11.79,0,0,0-5.33-9.23,3.77,3.77,0,0,0-3.76-.37h0Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.25,423.49a11.77,11.77,0,0,0-5.32-9.22c-2.94-1.7-5.33-.32-5.33,3.07a11.79,11.79,0,0,0,5.33,9.23C216.87,428.26,219.25,426.89,219.25,423.49Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.25,423.49a11.77,11.77,0,0,0-5.32-9.22c-2.94-1.7-5.33-.32-5.33,3.07a11.79,11.79,0,0,0,5.33,9.23C216.87,428.26,219.25,426.89,219.25,423.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.42,399.35h0a1.47,1.47,0,0,1-.54,2l-18.13,10.47a1.46,1.46,0,0,1-2-.54h0a1.47,1.47,0,0,1,.54-2l18.13-10.47A1.46,1.46,0,0,1,250.42,399.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.15,395.45h0a.86.86,0,0,1-.07,1.5l-18.47,10.67a2,2,0,0,1-2.14-.24h0a.86.86,0,0,1,.06-1.5L245,395.21A2,2,0,0,1,247.15,395.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.16,404.13h0a.86.86,0,0,0-1.34-.7L232.35,414.1a2,2,0,0,0-.87,2h0a.86.86,0,0,0,1.34.69l18.47-10.66A2,2,0,0,0,252.16,404.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.23,445v3.55l8.88-2.88s1.77-3.27,3.55-4.29l33.72-19.47,1-3-1-.6-33.72,19.47a3.55,3.55,0,0,1-3.55-.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.27,445.6v3.55l8.88-2.88s1.77-3.27,3.55-4.29l33.72-19.47V419L180.7,438.43a3.55,3.55,0,0,1-3.55-.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.27 449.15 167.23 448.55 167.23 445 168.27 445.6 168.27 449.15",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.23 445 168.27 445.6 177.15 438.24 176.11 437.64 167.23 445",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wrench--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--wrench--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301,424a1,1,0,0,1-.15.53,8.53,8.53,0,0,1-2.95,2.62c-3.62,2-8.81,2.59-13.28,1.66l-44.1,25.46s.05.09.08.14l.69-.12v2.51c0,1.88-1.26,3.78-3.78,5.21-5,2.84-13,2.81-18-.08l-.31-.2a.41.41,0,0,1-.19-.33v-2.36l11.48.66,1.68-3.5-.94-.55-3.46-2-10.69,1.55a.48.48,0,0,1-.54-.47v-2.63l3.1-.51s8.82-2.61,13.29-1.67L277,424.44a4.67,4.67,0,0,1-.76-2.62s0-2.48,0-2.48l.67.24A8.27,8.27,0,0,1,280,416.7c5-2.84,18.46-2,18.46-2v2.45a.25.25,0,0,1-.2.24L287,419l-.74,1.54-.94,2,4.41,2.58,10.95-3.95.27.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.18,453.7l-.94,2-3.46-2-10.69,1.55a.47.47,0,0,1-.54-.47v-2.63l11.23-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,416.5l11.47-1.85v2.47a.25.25,0,0,1-.2.24L287,419l-.74,1.54-.93-.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.6 428.82 284.6 426.31 240.5 451.77 240.5 454.28 284.6 428.82",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.66,449.06a8.4,8.4,0,0,0-3,2.69.59.59,0,0,0,.58.91l10.55-1.54,4.41,2.58-1.68,3.5-11,1.62c-.42.06-.55.23-.33.37l.4.24c4.92,2.89,13,2.92,18,.08,3.66-2.08,4.66-5.13,3-7.74l44.1-25.46c4.46.94,9.66.39,13.27-1.66a8.41,8.41,0,0,0,3-2.7.6.6,0,0,0-.59-.91l-10.54,1.55L285.35,420l1.68-3.5,11.05-1.62c.39-.06.53-.23.33-.36l-.4-.25c-4.93-2.88-13-2.92-18-.08-3.66,2.08-4.66,5.13-3,7.74l-44.1,25.47C228.47,446.45,223.27,447,219.66,449.06Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paint-pot--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Paint--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.08,334.77H437.89l1.72,27.15h0c0,2.52,1.61,5.06,4.91,7,6.62,3.91,17.42,4,24.12.26,3.38-1.91,5.07-4.44,5.06-7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.54,326.32c-7.51,4.23-7.58,11.21-.17,15.6s19.51,4.52,27,.29,7.59-11.21.17-15.6S451.05,322.09,443.54,326.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.42,334.44a4.66,4.66,0,0,1-.27,1.5c-.58,1.79-2.14,3.45-4.57,4.82a28.26,28.26,0,0,1-25.36-.27c-2.35-1.39-3.89-3.07-4.43-4.82a4.64,4.64,0,0,1-.27-1.6c0-2.33,1.74-4.57,4.84-6.3a28.26,28.26,0,0,1,25.36.27C472.78,329.85,474.44,332.12,474.42,334.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.06,337.47a25.83,25.83,0,0,0-12.7,2.89l-.18.11,0,0a28.26,28.26,0,0,0,25.36.27l.18-.11,0,0A26,26,0,0,0,457.06,337.47Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.23,345c.75-.42,1.34-.07,1.33.79a3,3,0,0,1-1.37,2.32c-.74.42-1.34.06-1.33-.79A3,3,0,0,1,464.23,345Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.34,342.35c-1.65,4.22-2.93,10,.75,12.69l.6.4,0,1.79c-.48-.3-1-.64-1.47-1-5.48-4.06-2.12-12.94,0-17.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.86,346.87c-.2.43-5.47,10.5-14.13,12.53a12.72,12.72,0,0,1-3,.35,15.13,15.13,0,0,1-8.07-2.52l0-1.79c3.58,2.49,7.18,3.34,10.7,2.53,8-1.88,13.12-11.69,13.16-11.78a.75.75,0,0,1,1-.32A.72.72,0,0,1,464.86,346.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Brushes--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Brush--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--brush--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.47,409h0a222.76,222.76,0,0,0-19.05,14.08,155.44,155.44,0,0,0-18.5,19l0,0,0,0h0a.87.87,0,0,0,1,1.34l.18-.08h0s13.3-7.42,22.08-14.8a222.34,222.34,0,0,0,17.08-16.31h0a1.09,1.09,0,0,0,.19-1,3.31,3.31,0,0,0-1.93-2.3A1.11,1.11,0,0,0,405.47,409Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.86,443.42l.18-.08h0s13.3-7.42,22.08-14.8c5.91-5,11.6-10.63,14.69-13.8L403.73,413s-35.45,30.41-36,29.86A.88.88,0,0,0,368.86,443.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.7,409.89c.77-.17,4.95-1,6.87-3.51a3.3,3.3,0,0,1-.58-1.07c-.47-1.5.63-2.2.39-3.37s-2.38-1-2.4-1h0a9.18,9.18,0,0,0-4.62,3.13,9.4,9.4,0,0,0-1.89,4.92l2.73,3.22h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,409.1c.26-1.38-.68-1.8-1.4-2.72-1.92,2.47-6.1,3.34-6.87,3.51l.5,2.34,1.52-.17.41-.06c.28,0,.56-.09.85-.16a11,11,0,0,0,1.34-.39,8,8,0,0,0,.93-.39,10.6,10.6,0,0,0,1.93-1.2A6.35,6.35,0,0,0,416,409.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,409.09c.12-.14.24-.29.35-.44l0,0,.23-.35.09-.14.06-.11c0-.07.07-.13.1-.2s.09-.16.12-.24.16-.38.23-.57.13-.39.18-.58.09-.39.13-.59a9.4,9.4,0,0,0-.07-3.62l-.06-.26,0-.07a2.45,2.45,0,0,0-.08-.29,10.26,10.26,0,0,0-.69-1.68c-.13-.24-.26-.47-.38-.67s-.25-.38-.37-.54a1.37,1.37,0,0,0-.17-.23l-.15-.2-.27-.31c-.15-.16-.24-.24-.24-.24a3.74,3.74,0,0,1-1.82,2.63A7.61,7.61,0,0,1,412,401s2.16-.18,2.4,1-.86,1.87-.39,3.37a3.3,3.3,0,0,0,.58,1.07c.72.92,1.66,1.34,1.4,2.72Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,397.72a9.78,9.78,0,0,1,.33,7.2,4.35,4.35,0,0,1-.77,1.46c.72.92,1.66,1.34,1.4,2.72h0c.12-.14.24-.29.35-.44l0,0,.23-.35.09-.14.06-.11c0-.07.07-.13.1-.2s.09-.16.12-.24.16-.38.23-.57.13-.39.18-.58.09-.39.13-.59a9.4,9.4,0,0,0-.07-3.62l-.06-.26,0-.07a2.45,2.45,0,0,0-.08-.29,10.26,10.26,0,0,0-.69-1.68c-.13-.24-.26-.47-.38-.67s-.25-.38-.37-.54a1.37,1.37,0,0,0-.17-.23l-.15-.2-.27-.31c-.15-.16-.24-.24-.24-.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.2,412.23a1.09,1.09,0,0,0,.19-1,3.31,3.31,0,0,0-1.93-2.3,1.11,1.11,0,0,0-1,0c-1.43.87-2.93,1.89-4.46,3a1.36,1.36,0,0,1,1.28-.06,4.2,4.2,0,0,1,2.44,2.9,1.38,1.38,0,0,1-.29,1.27C405.91,414.64,407.28,413.22,408.2,412.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.73,413a4,4,0,0,1,1,1.88,1.38,1.38,0,0,1-.29,1.27c1.47-1.5,2.84-2.92,3.76-3.91a1.09,1.09,0,0,0,.19-1,3,3,0,0,0-.69-1.38l-.06,0L403.73,413Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--brush--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--brush--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.77,406.72h0s-32.84,19.45-42.74,25.8a155.55,155.55,0,0,0-20.78,16.42h0l0,0h0a.85.85,0,0,0-.22.74.87.87,0,0,0,1,.71l.19-.06h0s14.15-5.65,23.8-11.85,41.08-28.25,41.08-28.25h0a1.09,1.09,0,0,0,.32-.93,3.34,3.34,0,0,0-1.63-2.52A1.12,1.12,0,0,0,433.77,406.72Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.54,410.45l1.68,1.82c-7.65,5.35-28.61,20-37.23,25.61l-.06,0-.94.6c-9.65,6.2-23.8,11.85-23.8,11.85h0l-.19.06a.87.87,0,0,1-1-.71C370.43,450.33,431.54,410.45,431.54,410.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.87,407.88c.79-.06,5-.39,7.27-2.6a3.42,3.42,0,0,1-.44-1.13c-.27-1.55.91-2.1.82-3.29s-2.24-1.29-2.26-1.29h0a9.27,9.27,0,0,0-5,2.52,9.44,9.44,0,0,0-2.51,4.63l2.3,3.55h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.18,408.17c.43-1.35-.45-1.88-1-2.89-2.23,2.21-6.48,2.54-7.27,2.6l.2,2.39c.48,0,1,0,1.53,0H438c.28,0,.57,0,.87-.05a12.19,12.19,0,0,0,1.38-.21c.31-.07.64-.16,1-.27a10.12,10.12,0,0,0,2.06-.95A5.94,5.94,0,0,0,444.18,408.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.19,408.15a3.78,3.78,0,0,0,.41-.39l0,0a3.74,3.74,0,0,0,.27-.31l.1-.13.08-.1c0-.06.09-.12.13-.19l.15-.22q.17-.27.3-.54a5.45,5.45,0,0,0,.25-.55c.08-.19.14-.37.2-.56a9.34,9.34,0,0,0,.4-3.61c0-.09,0-.18,0-.26v-.07c0-.11,0-.21-.05-.3a10.39,10.39,0,0,0-.47-1.76c-.09-.25-.19-.49-.29-.71s-.2-.41-.29-.58l-.14-.25-.13-.22c-.09-.13-.16-.24-.23-.33a2.35,2.35,0,0,0-.2-.28,3.75,3.75,0,0,1-2.15,2.38,6.88,6.88,0,0,1-1.28.44s2.17.1,2.26,1.29-1.09,1.74-.82,3.29a3.42,3.42,0,0,0,.44,1.13c.59,1,1.47,1.54,1,2.89Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.69,396.75a9.79,9.79,0,0,1-.6,7.18,4.34,4.34,0,0,1-.95,1.35c.59,1,1.47,1.54,1,2.89v0a3.78,3.78,0,0,0,.41-.39l0,0a3.74,3.74,0,0,0,.27-.31l.1-.13.08-.1c0-.06.09-.12.13-.19l.15-.22q.17-.27.3-.54a5.45,5.45,0,0,0,.25-.55c.08-.19.14-.37.2-.56a9.34,9.34,0,0,0,.4-3.61c0-.09,0-.18,0-.26v-.07c0-.11,0-.21-.05-.3a10.39,10.39,0,0,0-.47-1.76c-.09-.25-.19-.49-.29-.71s-.2-.41-.29-.58l-.14-.25-.13-.22c-.09-.13-.16-.24-.23-.33a2.35,2.35,0,0,0-.2-.28Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.07,410.27a1.09,1.09,0,0,0,.32-.93,3.34,3.34,0,0,0-1.63-2.52,1.12,1.12,0,0,0-1-.1,49.66,49.66,0,0,0-4.85,2.88c.32-.17.82-.6,1.32-.35a4.23,4.23,0,0,1,2.05,3.19c0,.58-.51.83-.82,1.05C433.13,412.19,435,411.14,436.07,410.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.54,410.45a3.92,3.92,0,0,1,.75,2c0,.58-.51.83-.82,1.05a48.32,48.32,0,0,0,4.6-3.22,1.13,1.13,0,0,0,.32-.93,3.11,3.11,0,0,0-.52-1.46l-.05,0-4.28,2.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--brush--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.88,408.05l19.73-11.36a1.5,1.5,0,0,0,.62-1.37,4.68,4.68,0,0,0-2.11-3.67,1.49,1.49,0,0,0-1.5-.15l-19.73,11.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.97 399.94 393.95 403.4 385.88 408.05 382.89 402.86 387.97 399.94",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.56,409.37l4-2.32-4-2.32,8.25-4.77a9.91,9.91,0,0,1,9,0l7,4.08a3.3,3.3,0,0,1,1.86,2.44c0,.1,0,4.08,0,4.95a3.23,3.23,0,0,1-1.85,2.46l-8.25,4.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.86,404l-7-4.08a9.91,9.91,0,0,0-9,0l-8.25,4.77,16,9.28,8.26-4.76C392.34,407.81,392.35,405.48,389.86,404Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.6 414.01 365.57 404.73 353.52 411.67 369.56 420.95 381.6 414.01",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.6 414.01 369.56 420.95 369.56 425.58 381.6 418.65 381.6 414.01",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.19 411.94 369.15 402.66 370.79 401.71 386.91 410.95 385.19 411.94",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.19 411.94 385.18 416.58 386.9 415.58 386.91 410.95 385.19 411.94",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.19 411.94 385.18 416.58 386.9 415.58 386.91 410.95 385.19 411.94",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.23,423.47s2.2-2.83,1-5.22l-4.7,2.7v4.64Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.23,423.47s2.2-2.83,1-5.22l-4.7,2.7v4.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.26,418.25a5.74,5.74,0,0,0-3.29-4.41c-2.19-.95-6.83,1-8.75-2.16-1.36-2.21.13-5.1.13-5.1l-8.83,5.09,16,9.28Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.52 411.67 353.51 416.3 369.56 425.58 369.56 420.95 353.52 411.67",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.52 411.67 353.51 416.3 369.56 425.58 369.56 420.95 353.52 411.67",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-15"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 404.99,
    cy: 148.07,
    r: 17.37,
    transform: "translate(217.73 536.5) rotate(-84.35)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.99,
    cy: 148.07,
    r: 13.81,
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 404.99,
    cy: 148.07,
    r: 13.81,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.43 167.32 331.09 181.29 318.62 180.51 319.61 165.03 332.43 167.32",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.41,140.48a5.95,5.95,0,0,0-7.89-6.51,5.84,5.84,0,0,0-3.31-6.4,7.44,7.44,0,0,0-5.74.23,4.49,4.49,0,0,0-2.5,2.14,6.29,6.29,0,0,0-11.47,1.55c-1.9-.42-4.58.42-5.43,2.31-1,2.15.21,4.8-.23,7-.29,1.46-.91,2.83-1.18,4.3a36.17,36.17,0,0,0-.47,5c-.26,6.89,15.74,11.37,15.42,16.1l8.53-10.38c0-.43,1.2-1.5,1.47-1.87.51-.68,1-1.42,1.44-2.13a13.29,13.29,0,0,1,5.88-4.7,10.86,10.86,0,0,0,4.2-3.45A7.53,7.53,0,0,0,348.41,140.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.69,152s2.76,4.11,2.4,4.54a6.53,6.53,0,0,1-2.11.9Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.25,139c2.68,1.37,7.33,3.89,8.52,13.61,1.22,10-1,13.46-2.42,14.77-.94.88-5.76,1.2-8.28.43-3.14-1-10-4.27-13.16-9.42-3.76-6.07-4.54-14.15-.2-17.31C323.82,136.61,331,137.84,333.25,139Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.09,167.54c-1.13.63-4.34.89-6.73.54l.07-1.8a17.76,17.76,0,0,0,3.19,1A10.89,10.89,0,0,0,339.09,167.54Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.43,138.7a10.46,10.46,0,0,1,3.12,1.8,4.15,4.15,0,0,1,1.11,1.42,3.38,3.38,0,0,1,.22,1.61,4.29,4.29,0,0,1-2.51,3.47,4.17,4.17,0,0,1,.68,3.47,8.33,8.33,0,0,1-2.46,3.55.62.62,0,0,1-.21.15.54.54,0,0,1-.44-.14c-1.69-1.12-2.73-3.07-5.11-2.29-3.13,1-3,4.89-.53,7.3a4.41,4.41,0,0,0,3,1.52,4.85,4.85,0,0,0,1.73-.15,7.24,7.24,0,0,1-4.19,6.6,17.27,17.27,0,0,1-9.35.11c-1.65-2.09-4.42-4.77-6.7-7.17-7.51-7.9-7.94-19.36,3.13-23,.39-.12.77-.24,1.16-.34a23.44,23.44,0,0,1,10.89-.23,23.16,23.16,0,0,1,5.19,1.75C333.58,138.34,334,138.52,334.43,138.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.78,157.54a2.32,2.32,0,0,0,1.42-3,2.37,2.37,0,0,0-3-1.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.5,173.94c-4.63-1.09-9.72,2.2-12.7,9.47s-8.95,24.41-10.19,29.27c-.56,2.17,16,22.83,15.38,22.54-.18-.09,5.38-9.39,5.38-9.39l-7.43-13.89,4.43-11.83Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,369.41c.53-.06.52,1.53.35,2.23s-2.28,3.05-6.15,4-9.28.37-11.59.35-6.26,1.23-8.55,1.63-6.46-.24-7.87-1.5a2.41,2.41,0,0,1-.63-1.88c0-1.54.13-1.85.31-1.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.31,367.8c-.06.3-.11.61-.16.92a15.19,15.19,0,0,0-.13,4.71,4.23,4.23,0,0,0,2.87,2,14.45,14.45,0,0,0,7.84-.17,22.63,22.63,0,0,1,5.92-.82,57.07,57.07,0,0,0,8.06.06,19,19,0,0,0,5.86-1.46A7.37,7.37,0,0,0,369,369.7a5.4,5.4,0,0,0-3.21-5.25,12.19,12.19,0,0,0-6-1c-2.25.1-3.94.46-5.94.39a9.79,9.79,0,0,1-4-.8,3.94,3.94,0,0,1-1.32-1.73c-.35-.7-.49-1.33-1.13-1.37,0,0-9.43.17-10.39.28s-1.13,4-1.24,4.7a17.3,17.3,0,0,1-.21,1.78C335.47,367,335.38,367.42,335.31,367.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.57,363.35a1.68,1.68,0,0,1,.48-.2c.91-.17,1.64.71,2.06,1.4a5.66,5.66,0,0,1,.53,1.35,3.27,3.27,0,0,1,.1,1.78c-.05.14-.15.32-.3.29s-.18-.2-.2-.34a6.94,6.94,0,0,0-.78-2.38,3,3,0,0,0-.59-.85,2.64,2.64,0,0,0-.93-.54c-.14-.05-.75,0-.62-.29a.38.38,0,0,1,.12-.13Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.93,363.45a1.71,1.71,0,0,1,1.22.29,2.44,2.44,0,0,1,.76,1.18,3.83,3.83,0,0,1,.19,3.07c-.17.29-.41.15-.52-.1a3.68,3.68,0,0,1-.14-.94,9.41,9.41,0,0,0-.64-2,2.91,2.91,0,0,0-.41-.73,1.34,1.34,0,0,0-.42-.36.77.77,0,0,0-.25-.1l-.25,0c0-.13.14-.21.26-.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.24,362.79a1.63,1.63,0,0,1,.79.49,2.38,2.38,0,0,1,.39.8,8.62,8.62,0,0,1,.44,2,2.53,2.53,0,0,1-.29,1.38c-.1.17-.28.33-.45.26s-.19-.38-.21-.55c0-.32,0-.65,0-1a5.64,5.64,0,0,0-1.21-3.24c0-.05-.07-.11-.06-.16s.14-.1.23-.09A3,3,0,0,1,350.24,362.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.39,363.51c.92-.05,2.93,1.15,4,4a16.24,16.24,0,0,1,.63,6.44,9.21,9.21,0,0,0,5.09-2.61,5.8,5.8,0,0,0,1.24-1.68,5.69,5.69,0,0,0-1.12-4.33c-1.41-1.57-3.53-2.55-6.83-2.62-3.7-.07-4,.92-4,.92Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.51,353.83s.3,4.85.67,7.09c.21,1.27,1.46,3.22,5.38,3.14,2.76-.05,4.26-1.64,4.62-3s.22-8.86.22-8.86Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.49,344.81l5.58-13.91,12.75,3.55s-10.08,14.8-11.09,16.14C287.07,352.78,281.49,344.81,281.49,344.81Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,348.67a7.26,7.26,0,0,0,0,1.68l.44,5.83a14.51,14.51,0,0,0,.32,2.29,14.19,14.19,0,0,1,.1,2.77c0,1,.05,1.93.06,2.9a5.06,5.06,0,0,1,0,1.23c-.1.41,6.12,4,8.64,5.35.14.08.29.14.45.22a4,4,0,0,0,4.08-1,6.92,6.92,0,0,0-1.69-7.63s-.32,0-.26-2.44c0-1.75,0-3.52.19-5.26a11,11,0,0,1,.83-3.2c.38-.93,1.1-1.91,1.07-2.95a4.53,4.53,0,0,0-1-2.06,6.29,6.29,0,0,0-1.52-1.65,11,11,0,0,0-4.41-2.18,2,2,0,0,0-1,0c-.5.15-.79.64-1.13,1.05a11.24,11.24,0,0,1-2.81,2.09,5,5,0,0,0-2.3,2.57C276,348.41,276,348.54,276,348.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.34,362.35a8.85,8.85,0,0,1,.81,1.18h0A8.76,8.76,0,0,1,290,370c4.4-.4,5.55-2.94,5.55-2.94a4.23,4.23,0,0,0-2.28-3.79,6.3,6.3,0,0,0-1-.5l0,0A6.4,6.4,0,0,0,288.34,362.35Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.73,349.31c-1.16.44-.86,3.62-.13,6.68s1.13,4.12.76,6.66-.59,3.68.45,4.61,9.28,4.79,9.28,4.79a30.51,30.51,0,0,1-1.84-9.55c-.22-5.64-.59-9.27-3.21-11.83A4.93,4.93,0,0,0,274.73,349.31Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.73,349.31c-1.16.44-.86,3.62-.13,6.68s1.13,4.12.76,6.66-.59,3.68.45,4.61,9.28,4.79,9.28,4.79a30.51,30.51,0,0,1-1.84-9.55c-.22-5.64-.59-9.27-3.21-11.83A4.93,4.93,0,0,0,274.73,349.31Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.59,367a15.46,15.46,0,0,1-6.89,3c-3.68.42-3.86-1-4.25-5.35s-.53-10.39-2.25-13.05-4.61-3.83-5.74-3.56c-.24-.12-1.36.72-1.73,1.23a6.27,6.27,0,0,1,4.82,1.93c2.29,2.24,2.71,7,2.82,11.3s.29,9.31,3.73,9.83a12.52,12.52,0,0,0,9.36-2.84A1.74,1.74,0,0,0,295.59,367Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.08,360.75a1.21,1.21,0,0,1,.51.8,2.48,2.48,0,0,1-1.25,2.26c-.47.27-.86.16-.12-.75A4.74,4.74,0,0,0,288.08,360.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.15,357.71a1.07,1.07,0,0,1,.31.66,3.76,3.76,0,0,1-1.51,2.38c-.81.36-.38-.53,0-.95A16.14,16.14,0,0,0,288.15,357.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.35,354.37a.74.74,0,0,1,.38.54c0,.35-1.64,1.6-2.16,1.56s-.64-.21,0-.65A21.33,21.33,0,0,0,288.35,354.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.92,342s25.4-38.92,26.17-41.89,5.58-33.88,5.58-33.88l5.6,36.33c-.56,2.6-1.69,7.76-1.71,10.79A118.67,118.67,0,0,0,332.18,331c1.92,12.65,4.15,24.5,4.15,24.5a10,10,0,0,0,5.43,1.19,14.47,14.47,0,0,0,6-1.75s1.95-33.89,2.34-41.65,1.12-12.45,1.35-17.56c.37-8.15.37-12.84-.38-27.79-.66-13.26-4-42-4-42L308,223.67s-3.73,5.66-4.14,22.55c-.32,13.2,0,50.27,0,50.27-6.05,3.8-7.9,7.73-10.79,15.16-1.82,4.68-6.51,19.23-7.9,23.53C290.27,336.58,294.92,342,294.92,342Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.7,266.36l-3.45-14.78s-5.87.42-13.09-5.36c0,0,.83,5.17,11,7.57l3.38,14.48-1.06,18S326.66,266.69,326.7,266.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.65,179.57c1.27-3.76,2.27-6.37,9.57-6l1,0c2.6.38,6.25.59,12.93,1.1.85.16,5.75,1,7.08,1.2l1.17.64c4.43,1.45,7.62,5.66,10.59,18.26.84,3.57-.57,9.71-3.62,11.84.38,12.93,2.09,29.51,2.09,29.51s-9.52,5.1-24.56,3.13c-13.45-1.77-19.42-9.69-18.95-8.68A132.05,132.05,0,0,1,312.65,211C305.57,193.6,305.76,185.16,307.65,179.57Z",
    style: {
      fill: "#092166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.54,175.44a46,46,0,0,1,14.69,2.41c8.08,2.67,26,6.47,26,6.47s23.35-9.61,24.41-10.74.64-3.58.45-4.92-.47-4.32-.72-5.16c-.43-1.48,1.68-1,2.86.46s1.59,4.1,2.19,4.59,5.7-4.73,8.18-7.25,3.67-4.31,5.16-3.12c1.07.85.26,2.39-1.54,4.56a29.81,29.81,0,0,0-2.32,2.89c-.22.39.37.75.6,1,.43.43,1.19,1.14,1.21,1.77a6,6,0,0,0,0,1c.18.76,1.09,1.17,1.31,1.93.16.55-.08,1.14,0,1.7.05.36.23.7.27,1.07a2.49,2.49,0,0,1-.85,1.9c-1.75,1.85-4,2.46-6.22,3.52-1.83.88-3.69,1.2-5.79,2s-26.79,16.61-31.08,16.36c-3.92-.23-18.24-2.18-26.42-3.33A15,15,0,0,1,335.39,176C335.48,175.63,335.54,175.44,335.54,175.44Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.37,239.7a53.58,53.58,0,0,1-7.45-.45c-12.26-1.61-18.43-8.33-18.94-8.74A124.45,124.45,0,0,1,312.65,211c-3.58-8.79-5.3-15.29-5.88-20.3.58,3.65,6,17.78,13,22,0,0-3.48,1.18-6.88,5.86S311.8,238.69,331.37,239.7Z",
    style: {
      opacity: 0.1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPDesigning);
export default __webpack_public_path__ + "static/media/p_designing.6e7278ca0ecd028cea201f18804a6fbc.svg";
export { ForwardRef as ReactComponent };